import zhLocale from "element-ui/lib/locale/lang/zh-CN";

const cn = {
  message: {
    tryBtn: "申请体验",
    registerBtn: '立即注册',
    experienceBtn: "立即体验",
    enterBtn: '立即进入',
    contactBtn: "联系我们",
    contactTxt: "联系我们，开启您的全球化业务开拓数智加速之旅！",
    contactTxtMobile: "联系我们，<br/>开启您的全球化业务开拓数智加速之旅！",
    contactMobileTxtSolution: "立即申请免费试用",
    tips: "提示",
    privacyPolicy: '隐私政策',
    terms: '使用条款',
    // 登录
    login: {
      loginWelcome: "登录",
      loginTitle:
        "AI驱动领域革新， <br/>助力产品/技术服务商开启全球业务开拓新征程。",
      loginUsername: "账户",
      loginPassword: "密码",
      rememberAccount: "记住账号",
      loginTips: "还没有账户？立即注册",
      loginButton: "登录",
      loginError: "登录失败",
      // 注册
      registerWelcome: "注册",
      registerUsername: "账户",
      registerPassword: "密码",
      registerConfirmPassword: "确认密码",
      registerTips: "已有账户？立即登录",
      registerButton: "注册",
      registerError: "注册失败",
    },
    userEdit: {
      userName: "用户名",
      confirmPassword: "确认密码",
      pleaseEnter: "请输入",
      msg1: "请输入新密码",
      msg2: "密码长度为8-18位，至少包含字母、数字、符号中的两种",
      msg3: "请再次输入密码",
      msg4: "两次输入密码不一致！",
    },
    // 头部
    header: {
      docs: '用户指南',
      // 顶部导航
      navList: [
        {
          name: "产品",
          children: [
            {
              name: "AI建站",
            },
            {
              name: "AI销售开拓助手",
              children: [
                {
                  name: "市场分析",
                  desc: "多维市场洞察与风险评估",
                  children: [
                    {
                      name: "客户搜索",
                    },
                  ],
                },
                {
                  name: "全球获客",
                  desc: "精准触达全球决策人",
                },
                {
                  name: "客户洞察",
                  desc: "深度解码客户需求痛点",
                  children: [
                    {
                      name: "客户管理",
                    },
                    {
                      name: "个性化EDM",
                    },
                  ],
                },
                {
                  name: "图文海报制作",
                  desc: "一键生成多语种海报",
                },
                {
                  name: "语音同传/策略沟通助手",
                  desc: "实时翻译与谈判辅佐",
                },
                {
                  name: "智能邮件",
                  desc: "高效撰写跨文化邮件",
                },
                {
                  name: "困境策略大师",
                  desc: "破解销售困境与话术",
                },
              ],
            },
            {
              name: "AI售前支持助手",
              children: [
                {
                  name: "售前顾问支持工具",
                  children: [
                    {
                      name: "痛点挖掘专家",
                      desc: "精准定位核心痛点",
                    },
                    {
                      name: "运营模拟分析平台",
                      desc: "快速生成定制方案",
                    },
                    {
                      name: "解决方案生成平台",
                      desc: "量化预演决策效果",
                    },
                    {
                      name: "远程实景Demo及培训平台",
                      desc: "远程沉浸式产品演示",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: "关于我们",
        },
        {
          name: "联系我们",
        },
      ],
      stageText1: '选择销售阶段',
      stageText2: '​明确潜在市场',
      stageText3: '查找目标客户',
      stageText4: '​联系触达客户',
      stageText5: '组织会议沟通',
      stageText6: '​挖掘客户需求',
      stageText7: '​提供定制方案',
      stageText8: '​推动客户立项',
      loginBtn: "立即登录",
      loginOutBtn: "退出登录",
      loginTips: "请先登录",
      logoutTips: "确定要退出登录吗？",
      logoutSuccess: "您已退出登录",
      phone: '联系电话',
    },
    // 首页
    index: {
      banner: {
        btnText: '申请体验',
        title: "企业客户(To B)<br/>全球业务AI开拓工具",
        content: "一站式提供 <span>获客+商机转化</span> 全流程开拓工具，<br/>助您解决各类出海问题：",
        beforeContent: '一站式提供全流程AI销售及售前顾问工具:',
        afterContent: '',
        content2: '企业服务及非标品业务AI业务开拓平台：<br/>一站式提供市场分析、全球获客、客户沟通、策略指导、售前顾问顾问、技术支持等全流程AI销售及售前顾问工具。',
        tools: [
          { text: '' },
          { text: '' },
          { text: '' },
          { text: '' },
          { text: '' },
        ],
        desc: "专为“企业服务及非标品业务”打造的一站式全球业务开拓平台！",
      },
      business: {
        title: 'Xpirory覆盖企业服务及非标品业务销售流程中超80%的业务环节',
        btnGroup: {
          btn1: '销售准备',
          btn2: '推广宣传',
          btn3: '客户开拓',
          btn4: '市场分析',
          btn5: '营销素材',
          btn6: '广告营销',
          btn7: '全球获客',
          btn8: '客户分析',
          btn9: '商务沟通',
          btn10: '售前顾问支持',
          btn11: '策略指导',
          btn12: '产品演示及培训',
          btn13: '商务活动',
          btn14: '投标及合同',
        },
      },
      tool: {
        title: '完善的产品及服务体系，助您高效找到市场及开拓客户!',
        content: [
          {
            title: 'AI获客及商机转化工具',
            desc: '若您希望团队自主使用各类工具，<br>我们可以提供强大完整的AI出海产品。',
          },
          {
            title: '代理运营服务',
            desc: '若您希望团队更专注于核心业务，<br>我们可以提供省心便捷的出海服务。',
          }
        ]
      },
      valuations: {
        title: '来自多个客户的评价。',
        msg1: '给俄罗斯客户设计跨境物流方案时，AI 自动分析莫斯科清关政策，生成的多币种报价单直接签单！客户开拓模块用俄语推送‘中欧班列时效对比’，本月新签10+客户！',
        msg2: '用了 AI 工具后，亚马逊选品效率直接翻倍！市场分析模块帮我们精准定位东南亚爆款，客户开拓功能自动生成多语言开发信，上周刚签了马来西亚代理商，比传统方式快了3个月！',
        msg3: '工厂转型做外贸愁坏了，AI 工具一键生成行业报告，帮我们锁定欧洲新能源设备需求。售前顾问顾问模块连客户可能问的技术参数都提前预判了，现在每天能跟进10+有效询盘！',
        msg4: '在开发越南电子厂客户时，通过平台用越南语自动搜集客户信息并做了深度分析，快速锁定了和客户的切入点，比以往自己做客户分析效率高了不止1倍。同时，使用AI模拟平台分析发现客户多个潜在优化点，前期调研沟通成本节省50%！！',
        msg5: '我真的太喜欢Xpirory的一站式业务开拓平台了，他帮助我快速的进行市场分析，市场开拓，客户开发等一些列的工作，真正提供了非常强大的帮助！',
        msg6: '之前客户一直对仓储管理方案改造效果不理解，去现场做Demo演示成本又特别高。后来我们通过远程Demo的演示让土耳其工厂的客户直观地感受到了方案应用效果，客户对技术的疑虑马上打消！项目推进周期比预期缩短至少45天！',
        msg7: '非标产品转型做外贸愁坏了，我们应该怎么找到目标市场？怎么找到对应的客户？怎么准备对应他们能理解的资料？后来我们发现Xpirory上这些问题全部都可以帮我们解决。从找市场，找客户，到客户跟进都有太多好用的工具了！',
        msg8: '利用平台的AI工具对客户进行洞察分析，并结合我们公司的业务重点，AI对EDM话术给出了详细的指导意见，比起自己去优化邮件效率提升了200%，并且指导过的邮件客户回复率增长了60%！',
        msg9: '作为 Xpirory 一站式业务开拓平台的深度用户，真的忍不住要为它打 call！从市场调研时的数据洞察，到客户开发阶段的精准触达，再到全渠道营销的高效落地，这个平台就像一位全能助手，把原本繁琐的营销流程变得清晰又高效。',
        msg10: 'Xpirory帮我们分析发现法国航空航天业客户的隐性需求，据此我们针对性地推送‘创新性的3D打印材料’方案！并且行业展会期间获得了大批客户咨询，订单转化率比以往提高了60%！',
        msg11: '以前去开拓马来西亚当地市场，我们投入了非常多的销售和售前顾问资源，现在通过Xpirory，我们轻松分析出了我们需要发力的重点区域和策略，而且直接就可以查询相关的目标客户，这让我们在海外开拓更加游刃有余了，并且节省了5成以上的差旅投入。',
        msg12: '客户对传感器部署有疑虑？通过在线实景远程Demo演示了多种场景的数据采集，英国客户当场就觉得要进行采购了！',
        msg13: '汪先生',
        msg14: '钱先生',
        msg15: '关女士',
        msg16: '王先生',
        msg17: '李先生',
        msg18: '冯先生',
        msg19: '白女士',
        msg20: '林女士',
        msg21: '跨境自动化技术输出商',
        msg22: '跨境ERP系统开发商',
        msg23: '国际物流方案集成商',
        msg24: '工业软件开发商',
        msg25: '制造业',
        msg26: '电子元件供应商',
        msg27: '金属加工设备商',
        msg28: '工业物联网服务商',
        msg29: '塑料机械制造商',
        msg30: '工业物联网服务商',
      },
      platform: {
        list: [
          {
            content: {
              title: "AI建站：把需求告诉AI，<br/>它帮你建站！",
              info: [
                {
                  title: "AI智能极速建站",
                  desc: "颠覆传统耗时的建站模式，文案、图片和排版统统交给AI处理。",
                },
                {
                  title: "内容AI智能生成",
                  desc: "AI自动撰写专业的网站宣传文案，再也不用为文案内容发愁。",
                },
                {
                  title: "零代码可视化编辑",
                  desc: "不懂代码也能按自己的想法灵活修改和更新网站内容。",
                },
                {
                  title: "一站式省心托管",
                  desc: "提供一站式的网站托管服务，你的业务今天就可以上线。",
                },
              ],
            },
          },
          {
            content: {
              title: "业务开拓：业务员躺着<br/>找客户的秘密武器",
              info: [
                {
                  title: "全球客户一键搜索",
                  desc: "覆盖全球市场，整合社交媒体与搜索引擎等多渠道数据，精准挖掘联系人邮箱，一键高效获客。",
                },
                {
                  title: "市场调研分析",
                  desc: "AI融合最新行业资讯，深度洞察市场情况，业务拓展不再迷失方向。",
                },
                {
                  title: "目标客户高效管理",
                  desc: "实时收录目标客户，轻松查看开发情况，分阶段精准营销。",
                },
                {
                  title: "客户深度洞察",
                  desc: "AI帮你全方位深度分析潜在客户的现状及开拓策略，让客户开发有的放矢。",
                },
                {
                  title: "千邮千面精准触达",
                  desc: "AI针对每个客户个性化生成邮件内容，EDM营销不再是千篇一律的广告传单。",
                },
                {
                  title: "图文海报智能生成",
                  desc: "通过描述即可一键生成营销图文素材，让多样化的营销形式不再依赖专业设计人员。",
                },
              ],
            },
          },
          {
            content: {
              title: "售前顾问支持工具：轻松打造<br/>专业全能的业务顾问",
              info: [
                {
                  title: "痛点挖掘及改善指南—现场运营痛点挖掘专家",
                  desc: "基于“场景地图”+“痛点菜单”选择的方式，轻松高效地帮助用户匹配最佳的数智化实践方案，快速获取大量有效项目机会。",
                },
                {
                  title: "AI精益改善顾问—现场运营模拟及分析平台",
                  desc: "用户通过导入人员、车辆、器具等资源数据，构建运营仿真场景，分析优化点，获取改善方案和预估效果，快速推动精益改善。",
                },
                {
                  title: "AI技术方案专家—AI方案在线生成平台",
                  desc: "通过AI，帮助用户轻松解锁行业场景，精准捕捉痛点，实时生成专业解决方案，提升效率，降低营销成本。",
                },
                {
                  title: "系统演示及方案验证工具—Demo及培训演示平台",
                  desc: "用户通过远程实景操控体验IoT产品优化现场管理和工作流程，直观了解产品特性，实时验证方案效果，显著降低验证成本。",
                },
              ],
            },
          },
        ],
      },
      values: {
        title: "核心价值",
        list: [
          {
            title: "快速获取客户",
            desc: "全球客户信息数据挖掘，找到精准岗位人群",
          },
          {
            title: "销售难题指导",
            desc: "不同销售阶段的难题，个性化指导针对客户的处理回复",
          },
          {
            title: "全面售前顾问支持",
            desc: "从客户痛点挖掘到客户情况模拟分析，到解决方案生成，再到Demo演示及培训全流程的售前顾问支持工具",
          },
          {
            title: "高效促成交易",
            desc: "让销售团队单位时间内开拓3~5倍甚至更多的客户机会，提高业务成交概率",
          },
          // {
          //   title: "行业痛点AI诊断，<br/>方案秒级生成",
          //   desc: "基于大模型分析客户业务场景，自动输出定制化数智解决方案，缩短60%方案设计周期。",
          // },
          // {
          //   title: "在线模拟验证，<br/>试错成本降低90%",
          //   desc: "IoT远程操控+3D实景模拟，预演设备部署与流程优化效果，规避真实场景试错风险。",
          // },
        ],
      },
      text1: 'AI产品',
      text2: '智能拓客邮件',
      text3: '邮件策略助手',
      text4: '产品宣传页制作',
      text5: '语音同传/策略沟通助手',
      text6: '一键生成多语种产品宣传页',
      text7: '我们解决什么问题?',
      text8: '代运营服务',
      text9: '获客工具',
      text10: '商机转化工具',
      text11: '代运营服务',
      text12: '获客阶段',
      text13: '商机转化阶段',
      text14: '适合自己的海外市场在哪里?',
      text15: '如何最大化利用好一次出国考察?',
      text16: '如何找到目标客户?',
      text17: '如何低成本出海?',
      text18: '国内团队能否做海外市场?',
      text19: '客户不搭理你该怎么办?',
      text20: '如何高效联系大量客户?',
      text21: '不懂外语怎么和客户沟通及开会?',
      text22: '对海外某个客户不了解怎么办?',
      text23: '海外新人或者合作伙伴如何快速掌握业务?',
      text24: '如何快速建立海外客户对你的专业印象?',
      text25: '遇到海外客户的挑战/质疑如何应对?',
      text26: '如何高效应对多个客户的产品/方案需求?',
      text27: '如何减少商机转化的差旅成本?',
      text28: '海外产品演示成本过高怎么办?',
      text29: '商机推进不下去了怎么办?',
      text30: '遇到竞争对手冲击怎么办?',
      text31: '客户需求不清晰怎么办?',
      text32: '我们能解决什么问题?',
      text33: '获客阶段主要环节',
      text34: '商机转化阶段主要环节',
      text35: '获客至转化：阶段环节、时间与成本解析',
      text36: '分析市场',
      text37: '客户联系',
      text38: '寻找客户',
      text39: '资料发送',
      text40: '客户分析',
      text41: '会议邀约',
      text42: '需求沟通',
      text43: '产品演示及培训',
      text44: '产品方案及<br />案例交流',
      text45: '销售策略',
      text46: '产品及方案<br />资料定制',
      text47: '商务活动',
      text48: '销售成本及周期占比',
      text49: '获客阶段 5~20%',
      text50: '商机转化阶段 80~95%',
    },
    // AI建站
    AIbuilding: {
      contactTxt: "准备好革新您的网站体验了吗？",
      banner: {
        content: "AI智能建站，<br/>90秒生成企业级网站",
        desc: "加载速度提升50%，100+行业专属模板，一站式省心托管！",
      },
      advantage: {
        list: [
          {
            title: `90秒极速建站<br/>效率提升<span class="text-primary">300%</span>`,
            desc: "传统建站需4-6周，AI建站仅需90秒",
          },
          {
            title: `多语言自动适配<br/>本地化成本降低<span class="text-primary">70%</span>`,
            desc: "支持多种语言自动翻译语义准确率98%",
          },
          {
            title: `一站式省心托管<br/>业务营销效率提升<span class="text-primary">80%</span>`,
            desc: "一站式的网站托管服务，效率提升80%",
          },
          {
            title: `无代码设计<br/>迭代效率提升<span class="text-primary">10倍</span>`,
            desc: "拖拽式+AI布局建议，设计时间减少90%",
          },
        ],
      },
      platform: {
        title: "老板自己就能搞定的专业官网",
        list: [
          {
            title: "智能建站引擎<br/>AI驱动的网站架构设计",
            desc: `基于2000万+行业数据点自动生成优化的页面结构<br/>一站式省心托管<br/>内容规划速度提升<span class="text-primary nums">80%</span>，业务营销效率提升<span class="text-primary nums">80%</span>`,
          },
          {
            title: "可视化智能编辑<br/>无代码设计工作室",
            desc: `拖拽组件，AI提供布局建议<br/>实时品牌规范检查<br/>设计迭代速度提升<span class="text-primary  nums">10倍</span>，<span class="text-primary  nums">100%</span>品牌一致性`,
          },
          {
            title: "实时多语言适配<br/>智能全球化本地化",
            desc: `自动翻译内容至12种语言，并进行上下文优化<br/>同步生成地区合规页面<br/>本地化成本降低<span class="text-primary  nums">70%</span>，加速全球业务扩展`,
          },
        ],
      },
      vs: {
        title: "传统建站 vs 我们的AI建站",
        column: {
          items: "",
          others: "传统建站",
          ours: "我们的AI建站",
        },
        list: [
          {
            items: "开发周期",
            others: "4-6周",
            ours: "<90 秒",
          },
          {
            items: "多语言支持",
            others: "手动翻译",
            ours: "12种语言自动生成",
          },
          {
            items: "移动端适配",
            others: "额外成本",
            ours: "包含并自动优化",
          },
          {
            items: "持续维护成本",
            others: "每月$500+",
            ours: "免费自动更新",
          },
        ],
      },
    },
    // 业务开拓工具
    business: {
      banner: {
        content: "智能商机挖掘与全周期客户开发",
        desc: `我们专注于通过全球商机智能挖掘、全周期客户开发和AI智能营销，帮助企业精准捕捉市场机会，<br />提升客户开发效率，实现持续增长。`,
      },
      video: {
        tabsList: [
          {
            label: "客户搜索",
          },
          {
            label: "客户管理",
          },
          {
            label: "客户洞察",
          },
          {
            label: "市场分析",
          },
          {
            label: "个性化EDM",
          },
          {
            label: "AI图文海报",
          },
        ],
      },
      platform: {
        list: [
          {
            content: {
              title: "客户搜索：<br/>全球商机智能挖掘",
              info: [
                {
                  title: "360°客户画像构建",
                  subTitle: "3分钟定位目标客户关键联系人",
                  desc: `<p>支持关键词/公司名称/行业标签等多维度搜索</p><p>整合LinkedIn、海关数据、行业报告等20+数据源</p>`,
                },
                {
                  title: "采供链关系图谱",
                  subTitle: "提前发现潜在合作机会，商机转化率提升300%",
                  desc: `<p>可视化展示客户上下游业务关系网</p><p>实时追踪客户采购及竞品合作动态</p>`,
                },
              ],
            },
          },
          {
            content: {
              title: "客户开发：<br/>全周期客户开发引擎",
              info: [
                {
                  title: "开发进展追踪",
                  subTitle: "销售跟进响应速度提升80%",
                  desc: `<p>邮件阅读次数、公司实时信息AI分析</p><p>根据客户互动触发EDM/短信/社媒触达</p>`,
                },
                {
                  title: "个性化EDM机器人",
                  subTitle: "打开率提升65%，回复率提升40%",
                  desc: `<p>多主题模板库，满足不同开发需求</p><p>结合企业洞察数据，AI智能动态改写邮件</p>`,
                },
              ],
            },
          },
          {
            content: {
              title: "客户洞察：<br/>AI赋能客户深度洞察",
              info: [
                {
                  title: "智能画像解码需求痛点",
                  subTitle: "3分钟快速找准合作机会",
                  desc: `<p>用AI分析客户现状和行业痛点，自动匹配你的优势资源，<br/>直接锁定最可能成交的合作场景。</p>`,
                },
                {
                  title: "策略沙盘预演商机转化",
                  subTitle: "给方法，能落地",
                  desc: `<p>提供与跟客户沟通痛点完整执行建议，帮你少走弯路快速拿单。</p>`,
                },
              ],
            },
          },
          {
            content: {
              title: "市场调研：<br/>智策市场分析通",
              info: [
                {
                  title: "多维数据全景洞察",
                  subTitle: "提升分析效率80%，助力决策周期缩短50%",
                  desc: `<p>智能整合市场规模、竞品份额及用户画像，<br/>AI算法实时预测市场饱和度与增长率，精准定位未开发需求。</p>`,
                },
                {
                  title: "智能策略与风控引擎",
                  subTitle: "风险预警准确率达90%，市场进入成功率提升70%",
                  desc: `<p>基于动态数据生成本土化营销策略、 <br/>定价模型及风险预警，确保决策高效可靠。</p>`,
                },
              ],
            },
          },
          {
            content: {
              title: "图文海报：<br/>AI智能营销工场",
              info: [
                {
                  title: "文生图海报引擎",
                  subTitle: "设计成本降低90%，素材产出效率提升10倍",
                  desc: `<p>输入描述关键词自动生成营销素材</p><p>智能适配社媒平台尺寸规范</p>`,
                },
                {
                  title: "品牌视觉管理系统",
                  subTitle: "确保全球营销物料品牌一致性",
                  desc: `<p>自动管理生成物料，便于二次营销</p><p>AI生成内容自动合规性检查</p>`,
                },
              ],
            },
          },
        ],
      },
    },
    // 售前顾问支持工具
    preSales: {
      banner: {
        content: "运营痛点挖掘<br/>改善评估及实践AI",
        desc: "为合作伙伴提供全方位的商业增长助力",
      },
      data: {
        list: [
          {
            label: "商机增加",
          },
          {
            label: "销售成本节约",
          },
          {
            label: "销售效率提升",
          },
          {
            label: "用户立项周期缩短",
          },
        ],
      },
      model: {
        title: '运营痛点挖掘、改善评估及实践AI',
        list: [
          {
            title: `现场运营<br/>痛点挖掘专家`,
            desc: `基于“场景地图”+“痛点菜单”选择的方式，轻松高效地帮助用户匹配最佳的数智化实践方案，快速获取大量有效项目机会。`,
          },
          {
            title: `AI方案<br/>自动生成平台`,
            desc: `通过AI辅助用户轻松解锁各行业典型业务场景，精准捕捉场景痛点，实时生成针对性的专业解决方案，有效提升工作效率，降低营销成本。`,
          },
          {
            title: `现场运营痛点<br/>模拟及优化平台`,
            desc: `用户通过导入人员、车辆、器具等资源行为数据，构建运营仿真场景，深入诊断分析现场运营优化点，获取相应的改善方案与预估的改善效果，加速精益改善过程。`,
          },
          {
            title: `现场运营<br/>改善实践平台`,
            desc: `用户通过远程实景操控的方式，亲身体验IoT产品对现场管理和工作流程的优化，直观了解产品特性，实时验证方案效果，大大缩短方案验证成本。`,
          },
        ],
      },
      platform: {
        list: [
          {
            tabTitle: `现场运营痛点挖掘专家`,
            title: `现场运营痛点挖掘专家`,
            desc: `基于"场景地图"+"痛点菜单"选择的方式，轻松高效地帮助用户匹配最佳的数智化实践方案，快速获取大量有效项目机会。`,
            videoList: [
              {
                label: `行业选择`,
                desc: `丰富的实景实践场地，满足多样化的Demo实践需求`,
              },
              {
                label: `场景痛点筛选`,
                desc: `场景及痛点直观展示，精准挖掘需求机会`,
              },
              {
                label: `方案查看`,
                desc: `多类型IoT应用方案快速匹配`,
              },
              {
                label: `预算及ROI预估`,
                desc: `投资预算及ROI快速预估`,
              },
            ],
          },
          {
            tabTitle: `AI方案自动生成平台`,
            title: `AI方案自动生成平台`,
            desc: `通过AI辅助用户轻松解锁各行业典型业务场景，精准捕捉场景痛点，实时生成针对性的专业解决方案，有效提升工作效率，降低营销成本。`,
            videoList: [
              {
                label: "行业选择",
                desc: `收集了丰富的行业场景，减少行业顾问人才投入`,
              },
              {
                label: "场景痛点筛选",
                desc: `场景及痛点直观展示，精准挖掘需求机会`,
              },
              {
                label: `AI方案自动生成`,
                desc: `AI一键自动生成方案及详细内容，效率成倍提升`,
              },
              {
                label: `方案在线快速编辑`,
                desc: `方案在线编辑功能，高效完成方案输出`,
              },
              {
                label: `丰富素材库选择`,
                desc: `提供丰富的素材库，满足个性化快速修改的需求`,
              },
              {
                label: `自定义方案模板及素材`,
                desc: `支持个性化模板及素材上传，满足用户多样化需求`,
              },
            ],
          },
          {
            tabTitle: `现场运营痛点模拟及分析平台`,
            title: `现场运营痛点模拟及分析平台`,
            desc: `用户可自主构建可视化的运营仿真现场，深入诊断分析各类运营资源的可改善点，获取相应的改善方案与预估的改善效果，加速精益改善过程。`,
            videoList: [
              {
                label: `基础数据录入`,
                desc: `支持自主导入现有资源的行为数据，快速构建仿真分析模型。`,
              },
              {
                label: `可视化仿真模拟`,
                desc: `生成可视化地图模拟仿真运营动态，全面展示各类资源的运营指标。`,
              },
              {
                label: `AI智能分析`,
                desc: `AI智能诊断分析可优化点，推荐对应方案与预估效果`,
              },
              {
                label: `优化方案对比`,
                desc: `自主组合多种改善方案集，直观对比改善效果，快速决策改善方向。`,
              },
            ],
          },
          {
            tabTitle: `现场运营改善实践平台`,
            title: `现场运营改善实践平台`,
            desc: `用户通过远程实景操控的方式，亲身体验IoT产品对现场管理和工作流程的优化，直观了解产品特性，实时验证方案效果，大大缩短方案验证周期，降低验证成本。`,
            videoList: [
              {
                label: `场景选择`,
                desc: `丰富的实景实践场地，满足多样化的Demo实践需求`,
              },
              {
                label: `资源赋能情况查看`,
                desc: `直观展示多种IoT产品对现场运营资源对象的赋能`,
              },
              {
                label: `参数自主配置`,
                desc: `支持自主配置场景中的多种参数，提供个性化的深度体验`,
              },
              {
                label: `实体对象实时操控`,
                desc: `沉浸式远程操控方式，多方位视角自由观察`,
              },
              {
                label: `业务改善效果体验`,
                desc: `随时随地快速验证及演示方案实际应用效果，低成本加速方案理解`,
              },
            ],
          },
        ],
      },
      core: {
        title: `核心功能价值`,
        list: [
          {
            label: `行业方案赋能`,
            desc: `丰富的行业全景图及核心场景应用方案，提供大量方案灵感及行业经验总结`,
          },
          {
            label: `多IoT融合，高ROI`,
            desc: `每个场景从单IoT到多IoT融合应用，多要素数字化赋能，提升效益，ROI更高`,
          },
          {
            label: `商机开拓增长`,
            desc: `帮助伙伴进行老客户新痛点挖掘，以及新客户新场景快速切入，获取大量有效需求`,
          },
          {
            label: `加速项目推进`,
            desc: `加速适配数智化场景、痛点及ROI，快速Demo验证，加速信息沟通效率`,
          },
          {
            label: `降低营销成本`,
            desc: `单次拜访可高效完成多场景多痛点“点菜式”交流；远程Demo验证，减少差旅成本`,
          },
          {
            label: `减少专业人才依赖`,
            desc: `AI方案自动生成，减少专业顾问人才依赖，<br/>降低人才成本投入`,
          },
        ],
      },
    },
    // 关于我们
    about: {
      contactTxt: '联系我们，开启您的全球化营销数智加速之路！',
      banner: {
        content: `AI驱动，专为“企业客户（To B）”<br/>打造的一站式全球业务开拓AI工具平台`,
        tools: [
          {text: 'analytics'},
          {text: 'leads'},
          {text: 'contact'},
          {text: 'guidance'},
          {text: 'consulting'},
          {text: 'support'},
        ],
        desc: "一站式提供<span>获客+商机转化</span>全流程开拓工具,助您解决各类出海问题。",
      },
      data: {
        list: [
          {
            label: "销售成本降低",
          },
          {
            label: "客户开拓效率提升",
          },
          {
            label: "客户成功率提升",
          },
          {
            label: "销售周期缩短",
          },
        ],
      },
      introduction: {
        title: "关于Xpirory",
        content: `
          <p>
            Xpirory是一家专注为企业客户（To B）提供“全球获客+商机转化”全流程AI开拓工具及科技运营服务的创新型公司。我们以AI驱动为核心技术优势，致力于通过智能化工具与数据洞察，帮助企业突破地域限制，在全球市场开启高效精准的业务开拓新征程。
          </p>
          <p>
            我们拥有企业级的AI业务开拓平台，深度整合市场分析、全球获客、客户洞察、策略指导、方案生成、商机转化等全流程服务，形成从市场洞察到客户转化的完整闭环。通过AI算法精准捕捉全球行业趋势与客群需求，结合多元化的AI自动化业务开拓工具，助力企业高效 触达目标客户、优化销售流程、提升线索转化率，让全球业务开拓变得轻松便捷。
          </p>
          <p><span style="font-weight: 700;border-bottom: 0.25rem solid #1a65ff;">我们的愿景</span>：成为全球企业客户出海业务开拓的核心驱动力！</p>
          <p><span style="font-weight: 700;border-bottom: 0.25rem solid #1a65ff;">我们的使命</span>：通过人工智能技术赋能企业实现智能化的业务开拓模式，加速拓展全球市场！</p>
          <p>
            Xpirory将持续投入AI技术研发力量，以全球化视野深耕行业场景，服务全球企业服务商。同时，我们也期待与更多合作伙伴携手，共同探索AI与业务开拓的深度融合，推动业务开拓模式的智能化转型，助力全球企业服务商在数字化浪潮中抢占先机，共创智能未来。
          </p>
          <p style="font-size: 1.375rem;font-weight: 700;">Xpirory，以科技链接全球市场，用AI重塑开拓范式！</p>
        `,
      },
    },
    // 定价
    pricing: {
      contactTxt: '联系我们，开启您的全球化业务开拓数智加速之旅！',
      banner: {
        content: `一站式业务开拓平台定价`,
        desc: "通过AI驱动的一站式业务开拓平台，助力企业快速开拓国际市场并实现高效转化",
      },
      vs: {
        column: {
          items: "",
          freeVision: "免费版",
          freeVisionInfo: `简要介绍...`,
          enterpriseVision: "企业版",
          enterpriseVisionInfo: `简要介绍...`,
          proVision: "高级应用版本",
          proVisionInfo: `简要介绍...`,
        },
        list: [
          {
            items: "服务场景",
            freeVision: "",
            freeVisionInfo: `简要介绍...`,
            enterpriseVision: "",
            enterpriseVisionInfo: `简要介绍...`,
            proVision: "",
            proVisionInfo: `简要介绍...`,
          },
          {
            items: "支持功能",
            freeVision: "",
            enterpriseVision: "",
            proVision: "",
            children: [
              {
                items: "功能点1",
              },
              {
                items: "功能点2",
              },
              {
                items: "功能点3",
              },
              {
                items: "功能点4",
              },
              {
                items: "功能点5",
              },
              {
                items: "功能点6",
              },
              {
                items: "功能点7",
              },
              {
                items: "功能点8",
              },
            ],
          },
          {
            items: "标准价格",
            freeVision: `XX<span class="fs_16 ml-1">元/小时</span>`,
            freeVisionButton: "点击进入",
            enterpriseVision: `XX<span class="fs_16 ml-1">元/小时</span>`,
            enterpriseVisionButton: "立即试用",
            proVision: `具体情况联系报价`,
            proVisionButton: "联系我们",
          },
        ],
      },
    },
    // 联系我们
    contact: {
      banner: {
        title: '联系我们',
        desc: '<span>【免费获取】</span> 3个匹配您业务的潜在客户+1个关键联系人+1封个性化开发信',
      },
      main: {
        title: '立即免费领取 3 个精准目标客户！',
        desc: '请填写以下表格，我们会尽快将客户资源包发送给您！',
        msg1: '填写完左侧表单后，<br/>您将<span>免费获得</span>：',
        msg2: '提出问题、反馈或只是打个招呼，<br/>我们期待各种形式的互动！',
        formItem1: '名',
        formItem2: '姓',
        formItem3: '电话',
        formItem4: '邮箱',
        formItem5: '公司名称',
        formItem6: '计划开拓的国家/地区',
        formItem7: '公司主推产品',
        submitBtn: '立即提交',
        successMsg: '提交成功!',
        failedMsg: '系统异常!',
        msg3: '基于您的业务领域、产品场景，精准匹配<span> 3 家潜在目标客户</span>',
        msg4: '附赠<span> 其中一家客户的关键联系人(电话/邮箱) </span>，直接触达决策层',
        msg5: '<span>定制化业务开发信 </span>(深度结合双方信息撰写，可直接使用)',
        msg6: '<span>零成本获取</span>全球业务AI开拓工具带来的惊人效果！',
      }
    },
    // 售前顾问支持工具New
    supportTools: {
      banner: {
        title: 'AI售前顾问支持助手：',
        content: `4大售前顾问能力支撑平台，有效线索产出<br>增加300%~500%，项目推进周期缩短30~40%。`,
        desc: "业务痛点深度挖掘，运营问题直观模拟，解决方案快速生成，应用效果高效演示！",
        mobileDesc: "业务痛点深度挖掘，运营问题直观模拟，解决方案快速生成，应用效果高效演示！",
        btnText: '申请体验',
      },
      tryBtn: '申请体验',
      platform: {
        btnGroup: {
          btn1: '痛点挖掘专家',
          btn2: '运营模拟分析平台',
          btn3: '解决方案生成平台',
          btn4: 'Demo及培训平台',
        },
        list: [
          {
            title: `业务痛点挖掘及改善指南，<br>高值痛点挖掘效率提升300%-500%`,
            videoList: [
              {
                label: `多行业场景配置`,
                desc: `打破跨行业的经验壁垒，赋能售前顾问多行业的业务经验， 减少专业顾问投入`,
              },
              {
                label: `高ROI痛点收录`,
                desc: `业务痛点结构化输出， 让每个一线业务人员具备专家级的痛点挖掘能力`,
              },
              {
                label: `最佳实践方案匹配`,
                desc: `绑定每个痛点的最佳实践方案，高效锁定客户需求方向`,
              },
              {
                label: `AI智能搜索助理`,
                desc: `随时响应的专属AI专家顾问,海量业务知识高效总结提炼`,
              },
            ],
          },
          {
            title: `AI精益改善顾问，运营趋势模拟，<br>改善价值评估效率成倍提升`,
            videoList: [
              {
                label: "便捷构建资源分析模型",
                desc: `支持自主构建资源行为数据，建立多维度的联动运营分析基础`,
              },
              {
                label: "可视化运营模拟分析",
                desc: `资源可视化运营动态模拟，全面展示各类资源的运营指标`,
              },
              {
                label: `AI智能分析及方案推荐`,
                desc: `AI全面精准挖掘潜在痛点，快速预估可量化的改善效果，降低投资方向误判风险`,
              },
              {
                label: `优化方案组合量化对比`,
                desc: `直观对比多种方案的量化指标变化，提供有效的决策依据，极大缩短立项周期`,
              },
            ],
          },
          {
            title: `多语言AI技术方案专家，解决方案<br>轻松生成，方案制作效率提升300%-500%`,
            videoList: [
              {
                label: `专业内容生成`,
                desc: `可指定多个参考文档，让AI生成内容更专业`,
              },
              {
                label: `生成语言选择`,
                desc: `多语言选择，轻松应对全球客户服务`,
              },
              {
                label: `可控方案模板`,
                desc: `轻松构建可控的方案生成模板，更匹配企业方案应用需求`,
              },
              {
                label: `快速在线编辑`,
                desc: `多种在线编辑工具和素材，高效完成方案调整`,
              },
              {
                label: `团队方案共享`,
                desc: `成熟标准方案一键收录，团队成员快速共享`,
              },
              {
                label: `场景地图关联`,
                desc: `自定义行业地图，痛点分类归纳，方案适用场景一目了然`,
              },
            ],
          },
          {
            title: `Demo远程实景演示，打破场地<br>和设备限制，演示成本降低90%`,
            videoList: [
              {
                label: `实践场地自由选择`,
                desc: `丰富的实景场景选择，无需部署安装，低成本满足多样化的Demo 演示需求`,
              },
              {
                label: `运营资源赋能方式展示`,
                desc: `直观展示资源对象赋能方式，抽象方案直观呈现`,
              },
              {
                label: `操控参数自主配置`,
                desc: `支持自主配置现场设备的多种参数，快速建立用户对设备的全面认知`,
              },
              {
                label: `实体对象实景操作`,
                desc: `多摄像头联动，低成本实现沉浸式 Demo操控体验`,
              },
              {
                label: `开放场景自由对接`,
                desc: `支持接入自有系统，实现软硬件一体化联动演示`,
              },
            ],
          },
        ],
      },
      valuations: {
        msg1: '给俄罗斯客户设计跨境物流方案时，AI 自动分析莫斯科清关政策，生成的多币种报价单直接签单！客户开拓模块用俄语推送‘中欧班列时效对比’，本月新签10+客户！',
        msg2: '以前和客户聊需求总在盲人摸象，现在用场景地图筛选痛点问题，客户直接对号入座，当场就说"这就是我们车间的问题！"，有效线索挖掘效率直接翻倍。',
        msg3: '把 MES 系统的接入Demo平台后，直接将软件的过点信息采集功能和采集硬件连通，低成本地让客户直观地看到了软件和硬件之间的配合效果，客户感慨到“比起原来我们自己手动扫描高效了很多啊。”一下子我们的项目订单又增加了近百万的现场采集设备的采购',
        msg4: '以前遇到和客户的销售难题，只能自己想办法，没想到在Xpirory上面的困境破局大师居然有详细的销售难题指导，并且总结归纳和很多种我们经常遇到的情况。这个对我们业务推进真的太有帮助了！',
        msg5: '车间主任一开始抵触新工具，现在自己都会用手机查看模拟结果，他说："比玩抖音还简单，我都教会三个班组长了"。',
        msg6: '给海外工厂做方案时，时差问题让沟通很头疼，现在直接共享实时模拟画面，德国工程师边看边改参数，项目周期缩短了 40%。',
        msg7: '给客户高层展示仓储优化方案时，用远程实景Demo进行现场演示，对方物流总监当场理解了方案的落地应用效果，同意立项打造自己的智能仓库，在以前可能得来来回回折腾好趟呢！',
        msg8: '给汽车厂客户讲方案时，客户临时要求调整方案的方向，我们通过解决方案生成平台，找到对应的参考资料，一下子就生成了针对该客户的新方案，一次沟通就锁定了客户的想法，不用再花几天时间来回修改方案，来回出差沟通了。',
        msg9: '上周给客户做了一下现场的运营模拟分析，屏幕上直观看到叉车空驶时间特别多，客户工程师都凑过来看："原来车辆利用率这么糟糕啊！"，当场就决定针对叉车做个专项优化。',
        msg10: '以前只敢接家电客户，现在用行业全景图连航空航天的转包业务都敢碰，销售经理说："AI 比老顾问知道的行业还多"。',
        msg11: '刚入职的销售用方案生成平台很快就上手了我们的业务，即使之前没有什么医疗行业的经验，他也完全可以对照客户场景，很快生成对应的介绍方案，他说："AI什么都懂，一个人见客户也没有太大的难度"。',
        msg12: '给客户讲解AGV协同管理的逻辑客户总是不能理解，我们使用Demo演示平台，通过远程实景画面直接操作给客户看，一下子他就懂了。直观的演示让客户对抽象的逻辑有了清晰的概念。关键是我们还不用真的搬几台AGV去现场演示给客户看。',
        msg13: '给电子厂做改善时，我们使用模拟分析平台进行评估，AI自动推荐了多种优化方案给我们，通过直观的数据对比，客户很快就确定了他想要先改善什么。',
        msg14: '关经理',
        msg15: '朱先生',
        msg16: '丁女士',
        msg17: '蒋先生',
        msg18: '李先生',
        msg19: '翟先生',
        msg20: '王先生',
        msg21: '光先生',
        msg22: '刘女士',
        msg23: '国际物流方案集成商',
        msg24: '某制造业集成商',
        msg25: '汽车行业',
        msg26: '某解决方案提供商',
        msg27: '工程公司',
        msg28: '轮胎行业',
        msg29: '某叉车改造解决方案商',
        msg30: '金属加工设备商',
        msg31: '系统开发商',
        msg32: '集成商',
        msg33: '工业物联网服务商',
      },
      values: {
        title: "核心价值",
        list: [
          {
            title: "深度挖掘客户痛点，<br>精准定位客户问题，<br>痛点准确率提升80%",
            mobileTitle: '深度挖掘客户痛点，<br>精准定位客户问题，<br>痛点准确率提升80%',
          },
          {
            title: "即时模拟运营趋势，<br>可视化传递价值认知，<br>客户认知率成倍提升",
            mobileTitle: '即时模拟运营趋势，<br>可视化传递价值认知，<br>客户认知率成倍提升',
          },
          {
            title: "快速生成解决方案，<br>高效响应客户需求，<br>客户满意度提升50%",
            mobileTitle: '快速生成解决方案，<br>高效响应客户需求，<br>客户满意度提升50%',
          },
          {
            title: "远程实景Demo演示，低<br>成本高效展示服务价值，<br>客户决策效率提升50%",
            mobileTitle: '远程实景Demo演示，低成本高效展示服务价值，客户决策效率提升50%',
          },
        ],
      },
    },
    // AI销售业务开拓助手
    developTools: {
      banner: {
        title: 'AI销售业务开拓助手：',
        content: `6大核心功能，让客户开拓效率提升300~500%，<br>企业销售成本降低40~50%。`,
        desc: "智能挖掘全球商机，精准触达目标客户，AI销售专家难题指导，助力企业业绩倍增!",
      },
      btnText: '市场分析',
      btnText2: '全球获客',
      btnText3: '客户洞察',
      btnText4: '图文海报制作',
      btnText5: '语音同传及策略沟通助手',
      btnText6: '智能邮件',
      btnText7: '困境策略大师',
      viewDetails: '查看详情',
      platform: {
        list: [
          {
            title: `精准分析目标市场，<br>踩坑风险减少80%`,
            videoList: [
              {
                label: `数据雷达`,
                desc: `整合行业近况、需求痛点、产业上下游、竞争及差异化、政策环境等多维度数据`,
              },
              {
                label: `市场导航`,
                desc: `在目标市场中分析进入路线、市场定位、运营策略等，帮助企业精准导航`,
              },
              {
                label: `风险评估`,
                desc: `结合政治、金融、法规等多方面信息评估市场风险和退出策略，未雨绸缪`,
              },
            ],
          },
          {
            title: `全球客户雷达，精准获取目标，<br>提效300%-500%`,
            videoList: [
              {
                label: "多维度搜寻客户",
                desc: `采购商、供应商、关键词等多维度搜索客户，获取客户信息，快速找到目标客户`,
              },
              {
                label: "采供链穿透",
                desc: `360度上下游分析，快速理清客户关系网`,
              },
              {
                label: `竞争品溯源`,
                desc: `顺藤摸瓜，找到竞品的客户`,
              },
            ],
          },
          {
            title: `客户洞察，精准掌握企业信息，<br>拓客成功率提升50%-80%`,
            videoList: [
              {
                label: `痛点扫描`,
                desc: `可通过分析客户的全方位可获取数据找到客户行业典型痛点，及供方与客户之间的可能合作机会`,
              },
              {
                label: `策略分析`,
                desc: `结合供方及客户的情况给出业务开拓的策略分析建议`,
              },
              {
                label: `风险评估`,
                desc: `结合客户市场情况及竞品信息给予竞争风险和合作风险评估`,
              },
            ],
          },
          {
            title: `营销资料高效制作，<br>成本降低80%`,
            videoList: [
              {
                label: `生图魔法`,
                desc: `多种行业及场景风格，快捷使用指导，高效生成专业图片`,
              },
              {
                label: `营销素材知识库`,
                desc: `构建丰富且随时可用的销售素材知识库供AI取用`,
              },
              {
                label: `海报达人`,
                desc: `无须专业编辑工具，即可快速结合知识库生成多语言营销海报，风格内容完全可控`,
              },
            ],
          },
          {
            title: `无障碍语音沟通，AI智能辅助<br>沟通效率大幅度提升`,
            videoList: [
              {
                label: `低延时语音同传翻译`,
                desc: `低延时同传翻译，直接说中文，对方即可听到翻译后的流利英文，没有中文原声干扰，跨境会议也能像和本地人交流一样简单`,
              },
              {
                label: `实时AI策略建议`,
                desc: `会议中自动分析对方话语，如质疑、施压、挑战等，实时推送应对策略，辅助业务人员轻松应对`,
              },
              {
                label: `智能术语解析`,
                desc: `自动捕捉行业术语或热度术语，实时提供术语解析，消除知识盲区，避免语义偏差，轻松保持与客户同频交流`,
              },
              {
                label: `一键对话总结`,
                desc: `会议结束后，一键总结会议要点及行动计划，省去人工整理，高效推动工作落地`,
              },
              {
                label: `隐身模式+小窗交互`,
                desc: `投屏后智能隐形，不出现在对方电脑屏幕，并且可以通过小窗模式进行最小化显示，不干扰正常投屏及沟通过程`,
              },
            ],
          },
          {
            title: `无障碍语言沟通，AI智能辅助<br>沟通效率大幅度提升`,
            videoList: [
              {
                label: `AI智能邮件话术生成`,
                desc: `结合销售阶段及业务背景，根据不同阶段的销售难题，自动生成个性化邮件话术及指导意见`,
              },
              {
                label: `多语种商务邮件翻译`,
                desc: `提供不仅在文字层面、 还包括对方文化中的商务交往习惯的多语言翻译`,
              },
              {
                label: `便捷邮件模板`,
                desc: `支持预编辑多种常用的邮件模板，便捷发送`,
              },
            ],
          },
          {
            title: `困境策略大师，<br>客户成功率提高50%-80%`,
            videoList: [
              {
                label: `销售难题库`,
                desc: `共享不同销售阶段的各类销售难题，快速找到参考`,
              },
              {
                label: `AI销售专家`,
                desc: `针对销售难题自动生成处理回复的方法和建议`,
              },
              {
                label: `个性化指导`,
                desc: `深度结合企业信息和客户信息，定制企业专属的指导意见`,
              },
            ],
          },
        ],
      },
      valuations: {
        msg1: '给俄罗斯客户设计跨境物流方案时，AI 自动分析莫斯科清关政策，生成的多币种报价单直接签单！客户开拓模块用俄语推送‘中欧班列时效对比’，本月新签10+客户！',
        msg2: '给迪拜智能交通项目投标时，AI 生成阿拉伯语动态流程图，把我们的 V2X 技术优势分步骤展示，评标专家说‘这是最清晰的方案’，中标后客户主动追加了 5G 基站订单',
        msg3: '给肯尼亚灌溉项目报价时，AI 提醒客户可能质疑设备耐腐蚀性，提前准备了盐雾测试报告 + 当地成功案例，谈判时直接堵住客户疑虑，项目利润率比预期高 8%！',
        msg4: '本来要放弃瑞典医疗设备市场，通过市场分析模块我们重新分析了瑞典市场情况，发现家庭护理设备需求有明显增长，我们立刻调整了推广的产品和方案，2个月内咨询量一下子翻了3倍！',
        msg5: '非常推荐这款便捷的图文海报制作工具。这款工具通过提供多种场景风格的模板，以及快捷的使用指导，大幅降低了营销资料制作的复杂性和成本，实现了高效生成专业图片的目标。',
        msg6: '业务员每次给客户写邮件费时又费力，而且总是没办法完全解决客户的顾虑。现在通过困境策略大师的功能，AI直接给出了保姆级的指导，每个业务员都可以轻松写出高质量的邮件，客户的成交周期缩短了至少30%。',
        msg7: '每次做客户背调都耗费好多时间，网上各种资料信息参差不齐，而且有些语种还要找翻译工具慢慢翻译过来看，实在是难受！现在只要选好目标语言，AI几分钟就可以在网上看完客户相关的资讯，给出开拓建议，和具体的业务结合点，这一下子就节省了4、5个专职人员的时间成本。',
        msg8: '给客户高层展示仓储优化方案时，用远程实景Demo进行现场演示，对方物流总监当场理解了方案的落地应用效果，同意立项打造自己的智能仓库，在以前可能得来来回回折腾好趟呢！',
        msg9: '过去在邮件中回复客户关于产品、价格、交期等各类质疑时，常常感到棘手。如今，有了 AI 销售专家的助力，针对销售难题提供专业指导并自动生成邮件内容，不仅让我们与客户的沟通变得更加顺畅高效，项目推进也明显轻松了许多。',
        msg10: 'AI 分析全球机械展会数据，生成的俄语版加工效率对比报告成了最佳谈资！市场获客模块自动匹配俄罗斯基建项目，莫斯科展期间新增客户线索 120+',
        msg11: '真的只有用上这个业务开拓工具，才知道原来营销可以这么简单，真的在营销方面节省了我们团队大量时间，我们以后还会一直用下去！',
        msg12: '给某个汽车客户做车联网方案时，通过客户洞察我们了解到他们的专利布局在某项技术上是空白，这刚刚好可以直接匹配我们的一款定制模块。于是我们立刻联系到客户，客户说‘你们补全了我们的技术拼图’。通过不断的努力，我们最终顺利拿下了项目！',
        msg13: '以前遇到和客户的销售难题，只能自己想办法，没想到在Xpirory上面的困境破局大师居然有详细的销售难题指导，并且总结归纳和很多种我们经常遇到的情况。这个对我们业务推进真的太有帮助了！',
        msg14: '周先生',
        msg15: '王先生',
        msg16: '周女士',
        msg17: '石女士',
        msg18: '蒋先生',
        msg19: '冯先生',
        msg20: '希女士',
        msg21: '李先生',
        msg22: '赵先生',
        msg23: '孙先生',
        msg24: '陈女士',
        msg25: '医疗设备提供商',
        msg26: '软件集成商',
        msg27: '国际物流方案集成商',
        msg28: '医疗IT提供商',
        msg29: '某解决方案提供商',
        msg30: '制造业',
        msg31: '软件外包商',
        msg32: '金属加工设备商',
        msg33: '系统开发集成商',
        msg34: '系统开发商',
        msg35: '某集成商',
        msg36: '工业物联网服务商',
      },
      values: {
        title: "核心价值",
        list: [
          {
            title: "精准分析目标市场，踩坑<br>风险减少80%",
          },
          {
            title: "全球客户雷达，精准获取<br>目标，效率提升300%-500%",
          },
          {
            title: "客户洞察，精准掌握企业信息<br>拓客成功率提升50%-80%",
          },
          {
            title: "困境策略大师，<br>客户成功率提高50%-80%",
          },
          {
            title: "营销素材高效制作，<br>成本降低80%",
          },
        ],
      },
    },
    // 解决方案生成平台
    solution: {
      banner: {
        title: '解决方案生成平台',
        content: `企业知识AI自学习+模板及内容<span style="color: #1A64FE">可控</span>，<br>3分钟完成专业个性化方案，<br>让售前<span style="color: #1A64FE">轻松应对全球客户需求</span>`,
      },
      title1: 'Xpirory 解决方案生成平台',
      desc1: '深度理解企业知识库，支持自定义方案模板，AI 自动生成多语言专业方案，可一键收录至知识地图实现知识共享。',
      title2: '多语言AI技术方案专家，解决方案<br>轻松生成，方案制作效率提升300%-500%',
      platform: {
        list: [
          {
            title: `专业内容生成`,
            desc: '可指定多个参考文档，让AI生成内容更专业',
          },
          {
            title: `兼容 Office PPT 编辑`,
            desc: '支持常规文档上传，操作与Office PPT一致，且辅助快速生成内容',
          },
          {
            title: `生成语言选择`,
            desc: '多语言选择，轻松应对全球客户服务',
          },
          {
            title: `可控方案模板`,
            desc: '轻松构建可控的方案生成模板，更匹配企业方案应用需求',
          },
          {
            title: `快速在线编辑`,
            desc: '多种在线编辑工具和素材，高效完成方案调整',
          },
          {
            title: `团队方案共享及快速微调`,
            desc: '成熟标准方案一键收录、团队快速共享，且支持通过提示词快速整体微调',
          },
          {
            title: `场景地图关联`,
            desc: '自定义行业地图，痛点分类归纳，方案适用场景一目了然',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '“懂业务” 的智能生成',
          desc: '深度理解企业知识库，可生成的企业可用的专业解决方案内容，而非普通科普介绍材料',
        },
        {
          title: '可控模板及内容生成',
          desc: '支持企业自定义专属模板，生成内容严格关联企业知识库，避免通用化表述，确保方案专业且贴合业务',
        },
        {
          title: '方案复用及快速微调',
          desc: '历史方案按场景分类存档，可一键调用并快速调整适配新客户的微调点，多语言版本同步生成，大幅减少重复劳动',
        },
      ],
      scene: [
        {
          title: '客户方案快速定制',
          desc: '面向各类客户的想法，能快速定制个性化解决方案，不必担心线索不靠谱导致的无效售前资源投入',
        },
        {
          title: '海外多语言方案输出',
          desc: '快速为不同国家和地区的客户生成海外版方案，解决语言障碍，提高海外客户响应速度',
        },
        {
          title: '不同客户间方案快速复用',
          desc: '面对同行业不同客户时，可直接复用同类场景方案，仅需微调提示词，即可快速生成适配方案',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '方案制作耗时',
            },
            {
              label: '多语言输出',
            },
            {
              label: '知识复用率',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工模式',
            },
            {
              label: '定制方案 10+ 小时',
            },
            {
              label: '需专业翻译，耗时长',
            },
            {
              label: '难',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `定制方案 10-30 分钟<br/>（快速微调复用仅需1分钟）`,
            },
            {
              label: 'AI 自动生成，耗时短',
            },
            {
              label: '易',
            },
          ]
        },
      ],
      footerText: '立即申请免费试用',
    },
    // 痛点挖掘
    painPoints: {
      banner: {
        title: '痛点挖掘专家',
        content: `让每个销售都可拥有专家级痛点挖掘能力，<br><span style="color: #1A64FE">快速把握需求，让商机倍增</span>`,
      },
      title1: 'Xpirory 痛点挖掘专家',
      desc1: '通过构建企业专属知识体系，将专家经验转化为可复用的痛点挖掘工具，支持自然语言检索客户问题，助力一线人员完整捕捉高价值需求。',
      title2: '业务痛点挖掘及改善指南，高值痛点挖掘效率提升300%-500%',
      platform: {
        list: [
          {
            title: `多行业场景配置`,
            desc: '打破跨行业的经验壁垒，赋能售前顾问多行业的业务经验，减少专业顾问投入',
          },
          {
            title: `高ROI痛点收录`,
            desc: '业务痛点结构化输出，让每个一线业务人员具备专家级的痛点挖掘能力',
          },
          {
            title: `最佳实践方案匹配`,
            desc: '绑定每个痛点的最佳实践方案，高效锁定客户需求方向',
          },
          {
            title: `AI智能搜索助理`,
            desc: '随时响应的专属AI专家顾问，海量业务知识高效总结提炼',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '专家经验 “标准化”',
          desc: '将资深顾问的痛点挖掘逻辑转化为可复用工具，人人都能快速掌握 “如何挖掘客户痛点”，传统模式依赖个人经验传承',
        },
        {
          title: '分层引导挖掘',
          desc: '通过 “行业→场景→痛点” 三层架构，引导用户从模糊感觉拆解到具体问题',
        },
        {
          title: '自然语言精准检索',
          desc: '客户用口语化提问，AI 能秒级匹配对应解决方案，完美弥补每个人的知识储备差异',
        },
      ],
      scene: [
        {
          title: '老客户新机会挖掘',
          desc: '通过AI智能检索，对老客户的问题快速诊断，找到对应方案，快速孵化新的项目机会',
        },
        {
          title: '新客户新机会挖掘',
          desc: '分层引导，对新客户新机会进行全面挖掘，让项目开拓效率倍增',
        },
        {
          title: '给合作伙伴赋能',
          desc: '通过AI赋能，让合作伙伴也轻松具备原厂商一样的客户痛点挖掘及需求把握能力',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '痛点挖掘效率',
            },
            {
              label: '高价值痛点识别率',
            },
            {
              label: '方案匹配精准度',
            },
            {
              label: '业务培训周期',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工模式',
            },
            {
              label: '一次拜访沟通可能只能找到1个痛点',
            },
            {
              label: '低',
            },
            {
              label: '低',
            },
            {
              label: '长',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `一次拜访沟通可以找全所有痛点及需求`,
            },
            {
              label: '高',
            },
            {
              label: '高',
            },
            {
              label: '短',
            },
          ]
        },
      ],
    },
    // 运营模拟分析平台
    simulation: {
      banner: {
        title: '运营模拟分析平台',
        content: `让方案效果直观可见<br><span style="color: #1A64FE">决策周期缩短 60%</span>`,
        desc: '可视化模拟+量化对比，快速确定改善方向',
      },
      title1: 'Xpirory 运营模拟分析平台',
      desc1: '上传客户现场地图与资源数据后，生成可视化运营模拟场景，AI智能诊断问题并推荐优化方案，通过多方案量化对比，辅助客户立项决策。',
      title2: 'AI精益改善顾问，运营趋势模拟，改善价值评估效率成倍提升',
      platform: {
        list: [
          {
            title: `便捷构建资源分析模型`,
            desc: '支持自主构建资源行为数据，建立多维度的联动运营分析基础',
          },
          {
            title: `可视化运营模拟分析`,
            desc: '资源可视化运营动态模拟，全面展示各类资源的运营指标',
          },
          {
            title: `AI智能分析及方案推荐`,
            desc: 'AI全面精准挖掘潜在痛点，快速预估可量化的改善效果降低投资方向误判风险',
          },
          {
            title: `优化方案组合量化对比`,
            desc: '直观对比多种方案的量化指标变化，提供有效的决策依据，极大缩短立项周期',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '精益专家经验赋能',
          desc: '通过AI将精益专家经验快速应用到每个客户身上，让宝贵经验不再稀缺',
        },
        {
          title: '多方案可视化对比',
          desc: '支持分别对比多套优化方案，用图表直观展示指标差异，辅助客户快速决策改善方向',
        },
        {
          title: '量化效果预演',
          desc: '不止指出问题，更能模拟优化后的改善数据，快速推动项目立项',
        },
      ],
      scene: [
        {
          title: '运营改善机会诊断',
          desc: '利用AI为客户低成本快速分析现场运营的瓶颈，推荐改造方案',
        },
        {
          title: '方案优化效果预演',
          desc: '预览改善后的运营效果，帮助客户明确投资回报预期',
        },
        {
          title: '推动多方案决策落地',
          desc: '面对客户对多种可选方案的犹豫，多方案对比能快速锁定改善方向，加快立项进度',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '问题诊断耗时',
            },
            {
              label: '优化方案量化',
            },
            {
              label: '客户决策周期',
            },
          ]
        },
        {
          data: [
            {
              label: '传统模式',
            },
            {
              label: '长<br/>(以天为单位)',
            },
            {
              label: '定性描述',
            },
            {
              label: '平均 60 天<br/>(需实地验证)',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: '短<br/>(以分钟为单位)',
            },
            {
              label: '定量数据',
            },
            {
              label: '平均 15 天<br/>(模拟数据支撑快速立项)',
            },
          ]
        },
      ],
    },
    // 远程实景Demo及培训平台
    training: {
      banner: {
        title: '远程实景Demo及培训平台',
        content: `即时满足身临其境的Demo体验<br><span style="color: #1A64FE">成本降低 90%+</span>`,
        desc: '多机位交互+实时远程操作，大幅降低演示成本',
      },
      title1: 'Xpirory 远程实景Demo及培训平台',
      desc1: '通过远程多机位操控，让全球客户在线查看设备运行细节，支持交互操作，深度理解方案效果，降低差旅与演示成本。',
      title2: 'Demo远程实景演示，打破场地<br/>和设备限制，演示成本降低90%',
      platform: {
        list: [
          {
            title: `实践场地自由选择`,
            desc: '丰富的实景场景选择，无需部署安装，低成本满足多样化的Demo 演示需求',
          },
          {
            title: `运营资源赋能方式展示`,
            desc: '直观展示资源对象赋能方式，抽象方案直观呈现',
          },
          {
            title: `操控参数自主配置`,
            desc: '支持自主配置现场设备的多种参数，快速建立用户对设备的全面认知',
          },
          {
            title: `实体对象实景操作`,
            desc: '多摄像头联动，低成本实现沉浸式 Demo操控体验',
          },
          {
            title: `开放场景自由对接`,
            desc: '支持接入自有系统，实现软硬件一体化联动演示',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '互动式实景体验',
          desc: '客户可在线操作设备，模拟真实使用场景，传统远程演示多为静态视频，缺乏参与感',
        },
        {
          title: '多机位细节展示',
          desc: '实时切换现场摄像头，多机位观察“远程看不清细节”的痛点',
        },
        {
          title: '全球化轻量演示',
          desc: '无需客户到场或企业出差，全球客户可同步在线体验，大幅降低差旅与设备运输成本，相比传统现场演示成本高且覆盖范围有限的问题更具优势',
        },
      ],
      scene: [
        {
          title: '方案应用效果演示',
          desc: '为国内外客户快速远程演示非标方案的运行效果，推动客户项目立项',
        },
        {
          title: '跨国产品培训',
          desc: '为国外合作伙伴进行轻量化的快速远程培训，降低培训成本',
        },
        {
          title: '解决方案宣传直播',
          desc: '支持整体解决方案的直播营销，加速市场教育的过程',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '演示成本',
            },
            {
              label: '客户参与度',
            },
            {
              label: '方案理解度',
            },
            {
              label: '演示覆盖范围',
            },
          ]
        },
        {
          data: [
            {
              label: '传统模式',
            },
            {
              label: '高<br/>(差旅+设备运输+现场布置)',
            },
            {
              label: '低',
            },
            {
              label: '难',
            },
            {
              label: '单次限 1家客户<br/>(现场容量)',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: '低<br/>(仅需网络，成本降低 90%)',
            },
            {
              label: '高',
            },
            {
              label: '易',
            },
            {
              label: '不限客户数量<br/>(全球同步在线观看)',
            },
          ]
        },
      ],
    },
    // 市场分析
    marketAnalytics: {
      banner: {
        title: '市场分析',
        content: `AI 市场分析，5-10 分钟生成，<br><span style="color: #1A64FE">全语种信息来源+多维度分析</span><br>的高质量市场分析报告`,
      },
      title1: 'Xpirory 市场分析',
      desc1: '实时抓取目标市场所在国别的当地语言资讯及全球多国语种的相关信息资料，全方位智能分析目标市场的成熟度、饱和度、与您的业务匹配度、政策适配度、文化兼容性、竞品竞争力、财务风险等多个方面的信息。为出海企业或计划开拓新行业的企业提供市场选择的决策依据。',
      title2: '精准分析目标市场，踩坑风险减少80%，减少95%以上的时间投入',
      platform: {
        list: [
          {
            title: `数据雷达`,
            desc: '整合行业近况、需求痛点、产业上下游、竞争及差异化、政策环境等多维度数据',
          },
          {
            title: `市场导航`,
            desc: '在目标市场中分析进入路线、市场定位、运营策略等，帮助企业精准导航',
          },
          {
            title: `风险评估`,
            desc: '结合政治、金融、法规等多方面信息评估市场风险和退出策略，未雨绸缪',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '不止 “搬数据”，<br/>更给 “策略”',
          desc: '区别于传统工具单纯整合信息，AI市场分析工具可结合企业自身业务输出针对性的 “市场切入建议”，结论附溯源依据',
        },
        {
          title: '全语种实时抓取',
          desc: 'AI完整覆盖目标市场本地语言资讯（政策、新闻、竞品动态），避免因语言壁垒遗漏关键信息，随心所欲分析各个潜在市场',
        },
        {
          title: '分钟级响应',
          desc: '从数据抓取到报告生成全程自动化，压缩传统调研周期 90% 以上，助力企业快速迈出出海第一步',
        },
      ],
      scene: [
        {
          title: '新市场准入分析',
          desc: '企业计划开拓新市场，快速了解自身业务准入门槛与匹配度',
        },
        {
          title: '投资风险分析',
          desc: '评估目标市场财务风险、环境风险、政策风险等，提前规避投入风险',
        },
        {
          title: '市场竞争情况分析',
          desc: '分析竞品在目标市场的布局与弱点，制定针对性竞争策略',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '调研周期',
            },
            {
              label: '人力投入',
            },
            {
              label: '信息覆盖度',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工调研模式',
            },
            {
              label: '3-4周',
            },
            {
              label: '5人团队',
            },
            {
              label: '30%有效数据',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `几分钟`,
            },
            {
              label: '1人操作',
            },
            {
              label: '全语种线上信息资料挖掘',
            },
          ]
        },
      ],
      footerText: '立即生成你的首份市场报告',
    },
    // 全球获客
    globalCustomer: {
      banner: {
        title: '全球获客',
        content: `海量<span style="color: #1A64FE">高价值目标客户及决策人</span><br>快速查询，让业务开拓不再被动`,
      },
      title1: 'Xpirory 全球获客',
      desc1: '通过 “多维度组合搜索 + AI 实时分析 + 供应链穿透”，精准筛选目标客户并定位 VP 级决策人，附带企业概况、交易历史、联系方式等完整信息，降低获客成本与周期。',
      title2: '全球客户雷达，精准获取目标，提效300%-500%',
      platform: {
        list: [
          {
            title: `多维度搜寻客户`,
            desc: '采购商、供应商、关键词等多维度搜索客户，获取客户信息，快速找到目标客户',
          },
          {
            title: `采供链穿透`,
            desc: '360度上下游分析，快速理清客户关系网',
          },
          {
            title: `竞争品溯源`,
            desc: '顺藤摸瓜，找到竞品的客户',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '多源商业数据库',
          desc: '涵盖海关数据，社媒数据及多种商业数据，构成强大的To B业务商业数据库',
        },
        {
          title: 'AI智能检索匹配',
          desc: '通过AI能力智能匹配目标客户群体，帮助用户轻松实现主动出击',
        },
        {
          title: '智能洞察企业服务业务需求',
          desc: '配套AI客户洞察工具，深度探索客户潜在的企业服务业务及非标品业务需求',
        },
      ],
      scene: [
        {
          title: '潜在客户挖掘',
          desc: '自动化方案厂商开拓 “墨西哥” 市场，快速锁定与之服务匹配的目标企业',
        },
        {
          title: '竞品客户渗透',
          desc: '挖掘竞品的合作客户（如 “某竞品的北美代理商”），深度洞察其潜在需求及有效切入点',
        },
        {
          title: '合作伙伴开拓',
          desc: '通过查找与自身业务配套的供应商，共同开发最终用户，形成共赢合作',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '客户筛选周期',
            },
            {
              label: '决策人触达率',
            },
            {
              label: '获客成本',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工调研模式',
            },
            {
              label: '3 人团队耗时 2 周',
            },
            {
              label: '15%（多为基层对接人）',
            },
            {
              label: '展会 + 差旅 + 人工，成本高昂',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `输入条件后 10 分钟内锁定目标`,
            },
            {
              label: '>80%（直接触达 VP 级采购 / 技术决策人）',
            },
            {
              label: '工具成本仅为传统模式的 1/5',
            },
          ]
        },
      ],
    },
    // 客户洞察
    customerInsights: {
      banner: {
        title: '客户洞察',
        content: `相隔千里也能对海外客户进行深度<br>洞察，需求匹配<span style="color: #1A64FE">精准度提升 85%</span>`,
      },
      title1: 'Xpirory 客户洞察',
      desc1: '整合目标客户多语种全域数据（业务动态、采购历史、决策链等），分析自身业务与客户需求的匹配度，输出定制化开拓策略，让沟通更精准。',
      title2: '客户洞察，精准掌握企业信息，拓客成功率提升50%-80%',
      platform: {
        list: [
          {
            title: `痛点扫描`,
            desc: '可通过分析客户的全方位可获取数据，找到客户行业典型痛点，及供方与客户之间的可能合作机会',
          },
          {
            title: `开拓策略分析`,
            desc: '结合供方及客户的情况给出业务开拓的策略分析建议',
          },
          {
            title: `风险评估`,
            desc: '结合客户市场情况及竞品信息给予竞争风险和合作风险评估',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '需求深度匹配',
          desc: '不止生成客户画像，更分析 “企业产品能解决客户哪些痛点”，给出切入路径和业务契合点，以及潜在竞争对手信息，而传统工具仅提供基础信息',
        },
        {
          title: '跨文化偏好解码',
          desc: '结合当地商业文化习惯解析 “隐性需求”，避免文化差异导致的误判',
        },
        {
          title: '风险预判前置',
          desc: '自动筛选分析客户所在地的政策，洞察企业决策链变动等风险，预判风险，避免无效投入',
        },
      ],
      scene: [
        {
          title: '潜在客户需求解码',
          desc: '分析潜在客户的采购偏好，调整方案侧重点',
        },
        {
          title: '合作风险提前排查',
          desc: '预判合作风险，制定应对策略',
        },
        {
          title: '差异竞争优势探索',
          desc: '针对客户与竞品的合作痛点，设计差异化沟通话术',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '客户调研耗时',
            },
            {
              label: '需求匹配精准度',
            },
            {
              label: '沟通推进速度',
            },
            {
              label: '合作风险预判',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工调研模式',
            },
            {
              label: '2 人团队 1 周 / 1 家客户',
            },
            {
              label: '40%（依赖经验判断）',
            },
            {
              label: '平均 3 次沟通后明确需求',
            },
            {
              label: '无系统分析，依赖人工经验',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `1 小时 / 10 家客户`,
            },
            {
              label: '>85%（基于数据挖掘客户隐性需求）',
            },
            {
              label: '首次沟通即命中核心需求',
            },
            {
              label: '90% 高风险客户可提前预警',
            },
          ]
        },
      ],
    },
    // 图文海报制作
    smartPoster: {
      banner: {
        title: '图文海报制作',
        content: `10 分钟搞定 多语种海报<br>洞察，需求匹配<span style="color: #1A64FE">设计效率提升 80%+</span>`,
      },
      title1: 'Xpirory 图文海报制作',
      desc1: '结合企业业务知识生成多语言营销文案，支持上传品牌模板，AI 自动根据模板完成海报制作，大幅降低设计成本与周期。',
      title2: '营销资料高效制作，成本降低80%',
      platform: {
        list: [
          {
            title: `快捷生图、简单好用`,
            desc: '多种行业及场景风格，快捷使用指导，高效生成专业图片',
          },
          {
            title: `海报达人、快捷可控`,
            desc: '无须专业编辑工具，即可快速结合知识库生成多语言营销海报，风格内容完全可控',
          },
          {
            title: `构建海报知识库`,
            desc: '构建丰富且随时可用的销售素材知识库供AI取用',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '精准解析业务知识',
          desc: 'AI智能解析企业的各类业务资料，充分理解业务特点，快速生成精准可用的宣传文案',
        },
        {
          title: '品牌模板全可控',
          desc: '支持上传及编辑企业 VI 模板（LOGO、配色、字体），AI 生成时严格遵循规范，避免自由设计导致的品牌语言混乱',
        },
        {
          title: '版权无忧的专属素材',
          desc: 'AI 生成营销配图，替代图库素材，有效规避侵权风险，解决传统设计常因版权问题被迫更换素材',
        },
      ],
      scene: [
        {
          title: '多语言素材快速制作',
          desc: '为不同市场定制各类当地语言的营销海报，轻松覆盖多个市场',
        },
        {
          title: '社交媒体本地化营销',
          desc: '轻松制作社交媒体的本土化高频宣传资料，丰富社媒内容输出',
        },
        {
          title: '个性化营销物料输出',
          desc: '针对不同客户，快速生成个性化的营销资料，让营销更精细',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '单版制作耗时',
            },
            {
              label: '多语言适配',
            },
            {
              label: '版权风险',
            },
            {
              label: '品牌统一性',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工模式',
            },
            {
              label: '5-8 小时 <br/>（设计 + 翻译 + 改稿）',
            },
            {
              label: '需专业翻译，易出错',
            },
            {
              label: '高（依赖图库素材）',
            },
            {
              label: '低',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `10 分钟 <br/>（AI 自动生成 + 排版）`,
            },
            {
              label: 'AI智能学习翻译<br/>多语言精准转换',
            },
            {
              label: '0 风险（AI 生成专属图片）',
            },
            {
              label: '高',
            },
          ]
        },
      ],
    },
    // 产品宣传页制作
    productPopularize: {
      banner: {
        title: '产品宣传页制作',
        content: `产品宣传资料高效制作，<br><span style="color: #1A64FE">文字、布局、风格、版式等皆可控</span>，<br>效率提高<span style="color: #1A64FE">300~500%</span>`,
      },
      title1: 'Xpirory 产品宣传页制作',
      desc1: '结合企业业务知识生成多语言营销文案，支持上传品牌模板，AI 自动根据模板完成产品宣传页制作，大幅降低设计成本与周期。',
      title2: '营销资料高效制作，成本降低80%',
      platform: {
        list: [
          {
            title: `文案图片口语化指令快速修改`,
            desc: '针对需要调整的文案和图片，通过口语化指令即可快速修改',
          },
          {
            title: `产品宣传页快速生成`,
            desc: '无须专业编辑工具，即可快速结合知识库生成多语言产品宣传页， 风格内容完全可控',
          },
          {
            title: `产品资料知识库`,
            desc: '构建丰富且随时可用的产品素材知识库供 AI取用',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '精准解析产品知识',
          desc: 'AI智能解析企业的各类产品资料，充分理解产品特点，快速生成精准可用的宣传文案',
        },
        {
          title: '品牌模板全可控',
          desc: '支持上传及编辑企业 VI 模板（LOGO、配色、字体），AI 生成时严格遵循规范，避免自由设计导致的品牌语言混乱',
        },
        {
          title: '版权无忧的专属素材',
          desc: 'AI 生成营销配图，替代图库素材，有效规避侵权风险，解决传统设计常因版权问题被迫更换素材',
        },
      ],
      scene: [
        {
          title: '多语言素材快速制作',
          desc: '为不同市场定制各类当地语言的营销海报，轻松覆盖多个市场',
        },
        {
          title: '社交媒体本地化营销',
          desc: '轻松制作社交媒体的本土化高频宣传资料，丰富社媒内容输出',
        },
        {
          title: '个性化营销物料输出',
          desc: '针对不同客户，快速生成个性化的营销资料，让营销更精细',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '单版制作耗时',
            },
            {
              label: '多语言适配',
            },
            {
              label: '版权风险',
            },
            {
              label: '品牌统一性',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工模式',
            },
            {
              label: '5-8 小时 <br/>（设计 + 翻译 + 改稿）',
            },
            {
              label: '需专业翻译，易出错',
            },
            {
              label: '高（依赖图库素材）',
            },
            {
              label: '低',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `10 分钟 <br/>（AI 自动生成 + 排版）`,
            },
            {
              label: 'AI智能学习翻译<br/>多语言精准转换',
            },
            {
              label: '0 风险（AI 生成专属图片）',
            },
            {
              label: '高',
            },
          ]
        },
      ],
    },
    // 语音同传及策略沟通助手
    speechTranslator: {
      banner: {
        title: '语音同传/策略沟通助手',
        content: `<span class="with-dot">低延时语音同传翻译</span><br/><span class="with-dot">AI实时策略建议及术语解析</span><br/><span style="color: #1A64FE">提升跨境/国内商务会议的沟通效率</span>`,
      },
      title1: 'Xpirory 语音同传/策略沟通助手',
      desc1: '专为企业商务会议设计，既能满足跨境沟通，又能满足本地沟通，聚焦 “业务 + 语言” 双需求：通过低延迟实时翻译、实时策略建议、专业术语解析、自动对话总结，解决传统会议中“业务能力和外语表达能力无法兼顾、行业术语或热点没有及时了解、沟通中难以对压力和挑战做出及时反应”等痛点，让跨境会议沟通更自然、更高效。',
      title2: '无障碍语音沟通，AI智能辅助沟通效率大幅度提升',
      platform: {
        list: [
          {
            title: `低延时语音同传翻译`,
            desc: '低延时同传翻译，支持边说边译，无需等待整句话说完即开始翻译；直接说中文，对方即可听到流利英文且无中文原声干扰，跨境会议也能像和本地人交流一样简单',
          },
          {
            title: `实时 AI 策略建议`,
            desc: '会议中自动分析对方话语，如质疑、施压、挑战等，实时推送应对策略，1秒出现应对话术，辅助业务人员轻松应对',
          },
          {
            title: `智能术语解析`,
            desc: '自动捕捉行业术语或热点术语，实时提供术语解析，消除知识盲区，避免语义偏差，轻松保持与客户同频交流',
          },
          {
            title: `一键对话总结`,
            desc: '会议结束后，一键总结会议要点及行动计划，省去人工整理，高效推动工作落地',
          },
          {
            title: `隐身模式 + 小窗交互`,
            desc: '会议共享屏幕时，软件化身为半透明浮动小窗口，且对于“对方”是“隐身”状态，既不遮挡己方的屏幕内容介绍，又不会让对方发现',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '从“延迟翻译”到“同步传译”',
          desc: '区别于传统翻译工具 “需等完整语句结束才翻译”，低延迟AI同传实现 “边说边译”，会议节奏更高效',
        },
        {
          title: '对方不安装任何软件，己方可复刻自己声音',
          desc: '对方无需安装任何软件，直接听到的就是己方经过翻译后的外语声音，还可复刻自己的声音音色，让对话体验更加自然',
        },
        {
          title: '不止“语言转换”，更懂“策略应对”',
          desc: '融合“翻译 + 策略建议”，实时分析场景对话，提供专业应对建议，进一步赋能业务人员',
        },
        {
          title: '术语智能捕捉解析，避免沟通语义偏差',
          desc: '自动捕捉行业 / 热度术语，实时提供解析，消除知识盲区，助力与客户同频交流',
        },
      ],
      scene: {
        type1: '国际沟通',
        type2: '国内沟通',
        typeData1: [
          {
            title: '国际客户沟通',
          },
          {
            title: '国际商务谈判',
          },
          {
            title: '海外沟通策略辅助',
          },
          {
            title: '海外团队同事沟通',
          },
          {
            title: '海外人员招募',
          },
          {
            title: '海外合作伙伴拓展',
          },
        ],
        typeData2: [
          {
            title: '本地客户沟通',
          },
          {
            title: '本地商务谈判',
          },
          {
            title: '本地供应商交流',
          },
          {
            title: '国内合作伙伴拓展',
          },
          {
            title: '本地沟通策略辅助',
          },
          {
            title: '本地招聘辅助',
          },
        ],
      },
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '翻译延迟',
            },
            {
              label: '对方感知干扰',
            },
            {
              label: '术语理解准确率',
            },
            {
              label: '对话中的挑战回应',
            },
            {
              label: '会议纪要耗时',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工翻译模式',
            },
            {
              label: '延迟大',
            },
            {
              label: '高（需要等待翻译人员完成翻译）',
            },
            {
              label: '60%（依赖人工翻译经验）',
            },
            {
              label: '反应慢 （依赖个人能力）',
            },
            {
              label: '2 小时 / 场（人工整理）',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `延迟小`,
            },
            {
              label: '无（隐身模式，对方无感知）',
            },
            {
              label: '85%+（AI 智能解析行业术语）',
            },
            {
              label: '反应快（实时分析出建议）',
            },
            {
              label: '30 秒 / 场（AI 自动生成）',
            },
          ]
        },
      ],
    },
    // 智能邮件
    smartEmail: {
      banner: {
        title: '智能拓客邮件',
        content: `多语言智能拓客邮件话术沟通，<br/><span style="color: #1A64FE">千人千面</span>，<br/>沟通针对性和有效性大幅度提升`,
      },
      title1: 'Xpirory 智能拓客邮件',
      desc1: '聚焦企业服务及非标品出海的邮件营销与商务沟通场景，通过 AI 生成定制化多语言话术及个性化策略指导，适配目标市场商务礼仪，解决传统沟通中 “模板化回复率低、跨文化误解多” 的痛点，提升与海外客户的沟通效率。',
      title2: '无障碍语言沟通，AI智能辅助沟通效率大幅度提升',
      platform: {
        list: [
          {
            title: `AI 智能邮件“个性化”话术生成`,
            desc: '结合客户背景、联系人信息及业务详情，根据不同的营销阶段，自动生成个性化邮件话术及指导意见',
          },
          {
            title: `多语种商务邮件翻译`,
            desc: '提供不仅在文字层面、 还包括对方文化中的商务交往习惯的多语言翻译',
          },
          {
            title: `便捷邮件模板`,
            desc: '支持预编辑多种常用的邮件模板，便捷发送',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '从“套用模板”到“定制化沟通”',
          desc: '区别于传统邮件工具的固定模板，AI 会结合业务阶段及客户情况生成个性化沟通内容',
        },
        {
          title: '不止“翻译文字”，更懂“当地逻辑”',
          desc: '区别于传统翻译工具仅做字面转换，AI商务邮件翻译能更好兼顾目标国家的商务习惯，避免词不达意',
        },
        {
          title: '经典成功话术沉淀',
          desc: '成功沟通案例自动存档，形成专属营销话术库，可在同类情况中直接复用，避免“重复踩坑”',
        },
      ],
      scene: [
        {
          title: '新客户破冰',
          desc: '用适配当地文化的邮件话术快速建立连接，提升初次沟通响应率',
        },
        {
          title: '需求跟进',
          desc: '针对客户疑问生成有效回应话术及思路，加速需求确认',
        },
        {
          title: '谈判推进',
          desc: '通过生成针对性的智能邮件话术打破谈判中的施压和挑战，缩短沟通周期',
        },
        {
          title: '难题化解',
          desc: '客户对价格、方案存疑或需求模糊时，AI 生成话术破僵局，推进合作',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '邮件回复率',
            },
            {
              label: '多语言沟通成本',
            },
            {
              label: '跨文化误解率',
            },
            {
              label: '沟通周期',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工模式',
            },
            {
              label: '低',
            },
            {
              label: '需各语种专业翻译，翻译成本高',
            },
            {
              label: '高',
            },
            {
              label: '长',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `高`,
            },
            {
              label: 'AI 智能生成，成本降低90%',
            },
            {
              label: '低',
            },
            {
              label: '短',
            },
          ]
        },
      ],
    },
    // 困境策略大师
    strategyCoach: {
      banner: {
        title: '困境策略大师',
        content: `破解各类出海销售困境及各阶段<br>话术指导，<span style="color: #1A64FE">破局成功率提升 >70%</span>`,
      },
      title1: 'Xpirory 困境策略大师',
      desc1: '针对企业服务及非标品出海的全销售阶段（破冰 / 竞品对比 / 价格谈判等），生成定制化策略与实战话术，结合跨文化商务习惯，打破沟通僵局。',
      title2: '困境策略大师，客户成功率提高50%-80%',
      platform: {
        list: [
          {
            title: `销售难题库`,
            desc: '共享不同销售阶段的各类销售难题，快速找到参考',
          },
          {
            title: `销售话术策略专家`,
            desc: '针对销售难题自动生成处理回复的方法和建议',
          },
          {
            title: `个性化指导`,
            desc: '深度结合企业信息和客户信息，定制企业专属的指导意见',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '聚焦To B非标品业务',
          desc: '针对企业服务及非标定品业务决策链长，沟通环节多等业务痛点，提供不同阶段个性化的销售策略',
        },
        {
          title: '策略 + 话术双输出',
          desc: '不仅告诉你 “怎么做”，更告诉你“怎么说”',
        },
        {
          title: '跨文化谈判适配',
          desc: '结合目标市场习惯，优化语言策略，避免 “照搬国内经验” 导致的沟通失效',
        },
      ],
      scene: [
        {
          title: '需求模糊破局',
          desc: '深度分析客户多方面潜在需求，助力多维度主动出击',
        },
        {
          title: '竞品挑战攻坚',
          desc: '客户拿竞品压价：生成 “差异化价值拆解” 话术',
        },
        {
          title: '价格谈判拉锯',
          desc: '客户反复压价，针对性地提供破局谈判策略',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '困境响应时间',
            },
            {
              label: '破局成功率',
            },
            {
              label: '谈判周期',
            },
            {
              label: '利润保留率',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工模式',
            },
            {
              label: '2-3 天 <br/>（团队讨论 + 经验复盘）',
            },
            {
              label: '低',
            },
            {
              label: '长',
            },
            {
              label: '低',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `1分钟<br/>（AI 实时生成应对策略）`,
            },
            {
              label: '高',
            },
            {
              label: '短',
            },
            {
              label: '高',
            },
          ]
        },
      ],
    },
    // 邮件策略助手
    emailStrategy: {
      banner: {
        title: '邮件策略助手',
        content: `客户开发阶段，<span style="color: #1A64FE">个性化开发策略</span>指导<br>及<span style="color: #1A64FE">沟通话术</span>生成，沟通成功率提高<span style="color: #1A64FE">50%-80%</span>`,
      },
      title1: 'Xpirory 邮件策略助手',
      desc1: '针对企业客户(To B)全球业务开拓阶段，生成定制化邮件策略指导及沟通话术生成，结合跨文化商务习惯，打破沟通僵局。',
      title2: '邮件策略助手，客户沟通成功率提高50%-80%',
      platform: {
        list: [
          {
            title: `客户开发难题库`,
            desc: '客户开发不同阶段的各类难题，快速找到参考',
          },
          {
            title: `AI销售专家`,
            desc: '针对获客场景自动生成回复内容、方法和建议',
          },
          {
            title: `个性化指导`,
            desc: '深度结合企业信息和客户信息，定制企业专属的指导意见',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '聚焦ToB非标品业务',
          desc: '针对企业服务及非标定品业务决策链长，沟通环节多等业务痛点，提供不同阶段个性化的销售策略',
        },
        {
          title: '策略 + 话术双输出',
          desc: '不仅告诉你 “怎么做”，更告诉你“怎么说”',
        },
        {
          title: '跨文化谈判适配',
          desc: '结合目标市场习惯，优化语言策略，避免 “照搬国内经验” 导致的沟通失效',
        },
      ],
      scene: [
        {
          title: '需求模糊破局',
          desc: '深度分析客户多方面潜在需求，助力多维度主动出击',
        },
        {
          title: '竞品挑战攻坚',
          desc: '客户拿竞品压价：生成 “差异化价值拆解” 话术',
        },
        {
          title: '价格谈判拉锯',
          desc: '客户反复压价，针对性地提供破局谈判策略',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '困境响应时间',
            },
            {
              label: '破局成功率',
            },
            {
              label: '谈判周期',
            },
            {
              label: '利润保留率',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工模式',
            },
            {
              label: '2-3 天 <br/>（团队讨论 + 经验复盘）',
            },
            {
              label: '低',
            },
            {
              label: '长',
            },
            {
              label: '低',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `1分钟<br/>（AI 实时生成应对策略）`,
            },
            {
              label: '高',
            },
            {
              label: '短',
            },
            {
              label: '高',
            },
          ]
        },
      ],
    },
    // AI PPT 智能翻译
    aiTranslation: {
      banner: {
        title: 'AI PPT 智能翻译',
        content: `专为企业出海与跨境演示打造，<br>一键完成PPT翻译。`,
      },
      title1: 'Xpirory AI PPT 智能翻译',
      desc1: '聚焦演示文稿翻译+专业表达+版式保真三重需求，一站式解决PPT翻译慢、排版乱、术语不准等痛点，让出海演示、国际汇报、资料交付更高效、更专业。',
      title2: '多语翻译·格式无损·专业高效',
      platform: {
        list: [
          {
            title: `适配日常PPT文档格式`,
            desc: '轻松应对日常PPT文档翻译工作',
            list: [
              {
                label: '· 支持PPTX格式文档翻译',
              },
              {
                label: '· 支持多文件上传，批量翻译',
              },
              {
                label: '· 无需转换格式，上传即识别，不丢页',
              },
            ]
          },
          {
            title: `多语种覆盖`,
            desc: '覆盖主流商务语种，一份 PPT轻松走向全球',
            list: [
              {
                label: '· 支持中/英/日/韩/法/德等多语种互译',
              },
              {
                label: '· 智能选择源语言，一键切换目标语言',
              },
              {
                label: '· 满足海外客户汇报、方案交付、全球培训等场景',
              },
            ]
          },
          {
            title: `自定义术语`,
            desc: '企业专属术语库，译文更地道、更专业',
            list: [
              {
                label: '· 支持自建行业术语库',
              },
              {
                label: '· 固定专业译法，避免歧义，统一品牌表达',
              },
              {
                label: '· 翻译自动匹配术语，准确率大幅提升',
              },
            ]
          },
          {
            title: `自动适配原文排版`,
            desc: '翻译后版式自动适配，无需重新排版',
            list: [
              {
                label: '· 自动适配文本框',
              },
              {
                label: '· SmartArt、表格、标题层级完整保留',
              },
              {
                label: '· 导出即用',
              },
            ]
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '从 “排版混乱”到<br/> “版式保真”',
          desc: '区别于普通工具翻译后排版全乱，Xpirory 实现翻译后格式自动适配。',
        },
        {
          title: '从 “通用翻译”到<br/> “行业精准”',
          desc: '融合自定义术语+AI上下文理解，内容表达更精准。',
        },
        {
          title: '从 “单文件低效”到<br/> “批量高效”',
          desc: '支持更多页面批量翻译，企业办公更省时。',
        },
      ],
      scene: {
        type1: '国际商务',
        type2: '国内协同',
        typeData1: [
          {
            title: '海外客户提案',
          },
          {
            title: '海外培训课件',
          },
          {
            title: '国际商务宣讲',
          },
          {
            title: '全球产品发布',
          },
        ],
        typeData2: [
          {
            title: '跨区域团队汇报',
          },
          {
            title: '对外宣传材料',
          },
          {
            title: '多语言内部培训',
          },
          {
            title: '会议演示文稿',
          },
        ],
      },
      effect: [
        {
          data: [
            {
              label: '对比维度',
            },
            {
              label: '排版完整性',
            },
            {
              label: '翻译速度',
            },
            {
              label: '术语准确率',
            },
            {
              label: '人力成本',
            },
            {
              label: '翻译质量',
            },
          ]
        },
        {
          data: [
            {
              label: '其他PPT翻译工具',
            },
            {
              label: '易错乱、需重排',
            },
            {
              label: '慢、耗时长',
            },
            {
              label: '术语翻译随机，无法指定',
            },
            {
              label: '高(校对+ 排版)',
            },
            {
              label: '机器直译',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI PPT 翻译',
            },
            {
              label: `高度还原排版格式`,
            },
            {
              label: '高效、快速翻译',
            },
            {
              label: '自定义术语表+ AI精准理解',
            },
            {
              label: '低，一键完成',
            },
            {
              label: 'AI翻译',
            },
          ]
        },
      ],
    },
    // 机器人员工
    robot: {
      banner: {
        title: 'AI 机器人员工:',
        content: `<span style="color: #1A64FE;font-weight: 700;">7x24 小时</span>，<br/>全自动销售与售前服务。`,
        desc: `替代人工重复工作，自动获客、自动邮件沟通、自动分析客户、<br/>自动生成方案，大幅提升团队开拓及销售效率`,
      },
      title1: 'Xpirory AI 机器人员工 · AI销售机器人',
      title2: 'Xpirory AI 机器人员工 · AI售前机器人',
      platform: {
        list: [
          {
            title: `自主搜寻 / 分析客户`,
            desc: '7x24 小时自动搜寻全球目标客户，按行业、地区、规模精准筛选;自动分析客户背景、合作潜力、决策链信息',
          },
          {
            title: `个性化邮件沟通`,
            desc: '自动生成多语种个性化商务邮件，支持智能跟进与自动触发邮件序列，可清晰查看客户是否已查看、已回复等实时状态，精准掌握跟进进度',
          },
          {
            title: `市场分析`,
            desc: '简单指令轻松自动抓取全球行业动态、区域政策与市场趋势，快速生成全维度市场分析报告，精准判断市场潜力与竞争格局，为出海拓客提供科学决策依据',
          },
          {
            title: `客户情报分析`,
            desc: '智能采集并整合目标客户背景、经营状况、采购需求等关键信息，构建完整客户画像，帮助销售快速掌握客户情况，提升跟进精准度与成单率',
          },
        ],
      },
      platform2: {
        list: [
          {
            title: `挖掘客户痛点`,
            desc: '场景化分层引导挖掘客户痛点，高效辅助销售精确定位客户核心诉求;并结合不同业务场景与客户痛点，自动匹配对应的解决方案',
          },
          {
            title: `业务知识问答`,
            desc: '轻松构建企业专属知识库，7x24小时在线解答关于产品、方案，案例等多种业务知识',
          },
          {
            title: `资料翻译`,
            desc: '多语种实时翻译产品手册、案例、方案、宣传物料等各类PPT资料，支持自定义企业术语库翻译更专业;自动适配原文排版，导出即用',
          },
          {
            title: `解决方案生成`,
            desc: '简单指令一键生成个性化解决方案 PPT，基于企业自有可控方案模板制作，风格、版式、布局完全自主可控，智能匹配不同行业、不同客户的个性化需求',
          },
        ],
      },
      title3: '机器人员工的差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '客户触达效率',
            },
            {
              label: '多语种翻译成本',
            },
            {
              label: '市场/情报分析速度',
            },
            {
              label: '方案撰写效率',
            },
            {
              label: '团队人力占用',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工模式',
            },
            {
              label: '低，受人力与时间限制',
            },
            {
              label: '低，受人力与时间限制',
            },
            {
              label: '慢，需人工整理分析',
            },
            {
              label: '低，反复修改排版内容',
            },
            {
              label: '高，大量重复沟通事务',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI 机器人员工模式',
            },
            {
              label: `高，7x24小时自动触达，覆盖更广`,
            },
            {
              label: '低，AI智能生成，翻译成本降低90%',
            },
            {
              label: '快，10分钟完成市场&客户情报',
            },
            {
              label: '高，一键生成个性化专业方案',
            },
            {
              label: '低，销售聚焦高价值成单环节',
            },
          ]
        },
      ],
    },
    // 隐私政策
    policy: {
      date: '生效日期：2025年4月7日',
      msg: '导言',
      msg1: 'Xpirory是由XPIRORY PTE. LTD.（以下简称“我们”）开发及运营的在线服务平台。您在使用我们的产品及服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的Xpirory产品及服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。',
      msg2: '您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。',
      msg3: '如对本《隐私政策》或相关事宜有任何问题，请通过business development@xpirory.com与我们联系。',
      msg4: '1.我们收集的信息',
      msg5: '我们或我们的第三方合作伙伴提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。',
      msg6: '个人信息：您在注册账户或使用我们的服务时，向我们提供的相关个人信息，例如邮箱地址及其密码、用户名称、自定义的登录密码、手机号码、短信验证码等。',
      msg7: '位置信息：指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：',
      msg8: '您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；',
      msg9: '您可以通过关闭定位功能，停止对您的地理位置信息的收集。',
      msg10: '相机权限或相册（存储）权限：为您提供图像上传/下载服务。我们不会主动调用上述权限，仅在您使用本应用过程中并授予上述权限后，我们会使用上述信息以记录您在本应用的使用情况。',
      msg11: '设备及连接信息：例如用户 IP 地址、浏览器类型及版本、设备信息等。',
      msg12: '日志信息，指您使用我们的服务时，系统可能通过cookies、标识符及相关技术收集的信息，包括您的设备信息、浏览信息、点击信息，并将该等信息储存为日志信息，为您提供个性化的用户体验、保障服务安全。您可以通过浏览器设置拒绝或管理cookie、标识符或相关技术的使用。',
      msg13: '内容发布/上传：当您使用我们的服务，发布、生成各类分析报告和方案时，我们会主动收集您提供的内容信息，包括但不限于企业介绍、主营业务、产品资料、方案资料、客户名称、客户邮箱、与客户的沟通记录、用于分析的地图文件、模拟对象的行为数据、模拟对象数量等。如您发布的内容中包括其他个人/企业的重要信息，请您务必取得其他个人/企业的合法授权，避免非法泄露其他个人/企业的信息。',
      msg14: '交易支付记录：我们使用的是stripe第三方的支付聚合工具。具体支付过程将由stripe处理，我们会收集第三方反馈给我们的关于您的第三方支付渠道的user ID、交易金额、交易时间、交易商户、交易状态等信息。为了保证您的支付行为安全，第三方支付渠道会获取您的设备信息。上述信息是为我们向您提供服务所必须的信息。',
      msg15: '维护/改进我们服务之必须：为了保障您的账号与系统安全，防止恶意程序及反作弊、反欺诈，收集bug以及维护/改进我们服务。我们可能需要收集您的一些信息，包括：设备信息、上网记录、获取粘贴板信息、服务日志信息、账户及实名认证信息，及经您授权后我们从我们的关联公司、合作伙伴处收集的信息。',
      msg16: '其他信息：当您浏览、点击、搜索、查看、使用本服务时所产生的用户记录，我们会收集您的使用情况，作为服务网络日志保存。若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。',
      msg17: '2. 信息的存储',
      msg18: '2.1 信息存储的方式和期限',
      msg19: '我们会通过安全的方式存储您的信息，包括本地存储（例如利用APP进行数据缓存）、数据库和服务器日志。',
      msg20: '一般情况下，我们只会在为实现服务目的所必需的时间内或法律法规规定的条件下存储您的个人信息。',
      msg21: '2.2 信息存储的地域',
      msg22: '我们会按照法律法规规定，将境内收集的用户个人信息存储于新加坡境内。当您使用特定功能（例如跨境支付）时可能通过第三方服务（如Stripe、Google）传输至美国、欧盟等地。我们确保传输符合标准合同条款（SCCs）或等效机制。',
      msg23: '2.3 产品或服务停止运营时的通知',
      msg24: '当我们的产品或服务发生停止运营的情况时，我们将以推送通知、公告等形式通知您，并在合理期限内删除您的个人信息或进行匿名化处理，法律法规另有规定的除外。',
      msg25: '3.信息安全',
      msg26: '我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。',
      msg27: '4.我们如何使用信息',
      msg28: '我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：',
      msg29: '向您提供服务，包括身份验证、客户服务、安全防范、诈骗监测、存档和备份用途等场景，确保我们向您提供的产品和服务的安全性；',
      msg30: '与授权合作第三方共享。如经您合法授权，我们会与第三方分享您的个人信息，我们仅会处于合法、正当、必要、特定、明确的目的与第三方共享必要的个人信息，并适时采取加密、匿名化等手段保证您的信息安全。',
      msg31: '帮助我们设计新服务，改善我们现有服务；',
      msg32: '使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；',
      msg33: '向您提供与您更加相关的广告以替代普遍投放的广告；',
      msg34: '评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；',
      msg35: '软件认证或管理软件升级；',
      msg36: '让您参与有关我们产品和服务的调查。',
      msg37: '数据使用目的及法律依据：',
      msg38: '用途',
      msg39: '数据类型',
      msg40: '法律依据（GDPR）',
      msg41: '账户管理及服务履行',
      msg42: '邮箱、用户名称',
      msg43: '合同履行必要性',
      msg44: '支付处理',
      msg45: '支付信息',
      msg46: '合同履行',
      msg47: '服务优化与个性化推荐',
      msg48: '偏好设置、地理位置',
      msg49: '基于用户同意（通过Cookie授权弹窗获取）',
      msg50: '安全风控与反欺诈',
      msg51: 'IP地址、设备信息',
      msg52: '',
      msg53: '合法权益',
      msg54: '5.信息共享',
      msg55: '目前，我们不会主动共享或转让您的个人信息至第三方，除了部分为满足平台功能和业务开展的第三方合作方。当前已有的第三方合作方包括：',
      msg56: '支付处理商：Stripe、微信支付、支付宝。',
      msg57: '分析工具：Google Analytics（匿名化数据，禁用用户ID共享）。',
      msg58: '广告平台：Google Ads（遵守其数据使用政策）。',
      msg59: '为了投放广告，评估、优化广告投放效果等目的，我们需要向Google等第三方合作伙伴共享经去标识化处理的用户行为数据，要求其严格遵守我们关于数据隐私保护的措施与要求，包括但不限于根据数据保护协议、承诺书及相关数据处理政策进行处理，避免识别出个人身份，保障隐私安全。',
      msg60: '我们不会向合作伙伴分享可用于识别您个人身份的信息（例如您的姓名或电子邮件地址），除非您明确授权。',
      msg61: '我们不会对外公开披露所收集的个人信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。',
      msg62: '随着我们业务的持续发展，我们有可能进行合并、收购、资产转让等交易，我们将告知您相关情形，按照法律法规及不低于本《隐私政策》所要求的标准继续保护或要求新的控制者继续保护您的个人信息。',
      msg63: '另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得您的授权同意：',
      msg64: '为订立、履行您作为一方当事人的合同所必需，或者为履行我们的法定职责或者法定义务所必需；',
      msg65: '与公共安全、公共卫生、重大公共利益直接相关的；',
      msg66: '犯罪侦查、起诉、审判和判决执行等直接相关的；',
      msg67: '个人信息主体自行向社会公众公开个人信息的；',
      msg68: '从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；',
      msg69: '法律、行政法规规定的其他情形。',
      msg70: '6.您的权利',
      msg71: '在您使用我们的服务期间，我们可能会视产品具体情况为您提供相应的操作设置，以便您可以查询、删除、更正或撤回您的相关个人信息，您可参考相应的具体指引进行操作。此外，我们还设置了投诉举报渠道，您的意见将会得到及时的处理。如果您无法通过上述途径和方式行使您的个人信息主体权利，您可以通过本《隐私政策》中提供的联系方式提出您的请求，我们会按照法律法规的规定予以反馈。',
      msg72: '当您决定不再使用我们的产品或服务时，可以申请注销账户。注销账户后，除法律法规另有规定外，我们将删除或匿名化处理您的个人信息。',
      msg73: '7.儿童隐私',
      msg74: '我们不收集16岁以下儿童的信息，如果您发现任何 16 岁以下的人员非法向我们提供了个人数据，请与我们联系，我们将采取措施删除此类信息。',
      msg75: '8.变更',
      msg76: '我们可能适时修订本《隐私政策》的条款。当变更发生时，我们会在版本更新时向您提示新的《隐私政策》，并向您说明生效日期。请您仔细阅读变更后的《隐私政策》内容，若您继续使用我们的服务，即表示您同意我们按照更新后的《隐私政策》处理您的个人信息。',
    },
    // 使用条款
    useTerms: {
      date: '生效日期：2025年4月7日',
      msg1: 'XPIRORY PTE. LTD.（以下简称“Xpirory”）已更新适用于我方网站的使用条款。就本使用条款而言，“网站”统指Xpirory官方网站（www.xpirory.com）以及Xpirory运营且链接至本条款的所有其他网站。',
      msg2: '我们根据本《使用条款》（以下简称“条款”）向您提供网站服务，我们可能根据下文第1节的规定不时更新本条款。您访问或使用网站即表示接受并同意受本条款、Xpirory隐私声明及Xpirory Cookie政策的约束。若您不同意本条款，则不应访问或使用网站。此外，访问网站时，您应遵守网站上发布的任何适用规则或指南，此类规则或指南可能随时更新并纳入本条款。',
      msg3: '我们如何保护、收集和使用您提交并存储于服务中的电子数据、文本或其他材料（即“服务数据”）的实践与政策，详见隐私政策。',
      msg4: '1. 条款修改',
      msg5: '我们可随时修改本条款的任何部分，包括增删条款，修改内容将在发布后立即生效。您在发布后继续使用网站即视为接受该等修改。',
      msg6: '2. 网站变更',
      msg7: '我们可随时更改或终止网站的任何功能、服务或内容，包括但不限于内容、可用性及访问所需的设备。',
      msg8: '3. 注册',
      msg9: '您可能通过在线注册创建用户账户（“您的账户”），以使用网站特定功能。我们将根据隐私声明使用您提供的信息。注册时，您声明并保证所提供的信息在当前情况下真实、完整且准确。您同意及时更新网站信息以保持其真实性与完整性，并自行承担访问和使用网站所需的软硬件设备及相关费用。',
      msg10: '4. 用户内容准则',
      msg11: '以下条款适用于您提交的内容：',
      msg12: '4.1 网站包含信息查询、文件上传、文本输入等功能，您可在其中输入或上传用户自有文本内容、图片、文档等材料（统称“用户内容”）。您需对使用这部分功能的行为承担全部责任，且使用风险自担。网站功能仅对16岁及以上用户开放。提交用户内容即表示您声明自己年满16周岁；若未满18周岁，您需取得父母或法定监护人的合法同意。',
      msg13: '4.2 通过网站提交用户内容时，您同意不上传、发布或传播以下内容：',
      msg14: '(a) 侵犯他人权利（包括诽谤、骚扰、跟踪或威胁他人的言论）；',
      msg15: '(b) 您明知虚假、误导或不准确的内容；',
      msg16: '(c) 包含明显偏见、种族主义、种族或民族攻击性内容、仇恨言论、辱骂、低俗或脏话；',
      msg17: '(d) 含有或宣扬色情、性露骨内容、恋童癖、乱伦、兽交或其他淫秽内容；',
      msg18: '(e) 违反法律、教唆危险/非法/掠夺行为，或意图实施非法活动的讨论；',
      msg19: '(f) 宣扬暴力行为；',
      msg20: '(g) 对个人或公共安全构成合理威胁；',
      msg21: '(h) 以剥削、色情或不当目的为主展示杀戮或身体虐待的暴力图像；',
      msg22: '(i) 未经权利人明示许可，使用受版权、商标、商业秘密、肖像权或其他专有权利保护的内容；',
      msg23: '(j) 包含未经请求的广告、“垃圾邮件”、“链式信件”、“传销”等推广内容；',
      msg24: '(k) 未经许可使用可识别自然人的姓名或肖像；',
      msg25: '(l) 其他法律法规禁止的内容。',
      msg26: '您需对侵权行为导致的损害承担全部责任。Xpirory有权禁止违规用户继续提交内容。',
      msg27: '4.3 您不得暗示Xpirory对用户内容的认可。',
      msg28: '4.4 您不得上传含病毒或破坏性组件的用户内容。',
      msg29: '4.5 我们对用户内容的准确性不负责，由此产生的使用风险用户自担。',
      msg30: '5. 用户行为准则',
      msg31: '您同意：',
      msg32: '(a) 不干扰网站或相关网络的正常运行；',
      msg33: '(b) 不为商业目的复制、出售或利用网站内容；',
      msg34: '(c) 不从事非法活动；',
      msg35: '(d) 不冒充Xpirory或员工；',
      msg36: '(e) 不侵犯他人隐私。',
      msg37: '6. 知识产权',
      msg38: '网站上的所有文本、图形、商标、软件等内容均为Xpirory所有或授权使用，受版权、商标法等保护。未经书面许可，不得以任何形式复制、传播网站内容，个人非商业用途且保留权利声明的情况除外。',
      msg39: '7. 免责声明及责任限制',
      msg40: '(A) 使用网站风险自担。Xpirory不保证网站无中断或错误。',
      msg41: '(B) 网站按“现状”提供，不提供任何明示或默示担保（法律强制要求的除外）。',
      msg42: '(C) 在法律允许的最大范围内，Xpirory不对因使用网站导致的直接、间接、附带或后果性损害（包括数据丢失、商誉损失等）承担责任。',
      msg43: '(D) 我们对未经授权访问您的个人信息不承担责任。',
      msg44: '8. 终止与暂停',
      msg45: '我们可随时终止或暂停您对网站的访问，且不承担通知义务。',
      msg46: '9. 版权与版权代理人',
      msg47: '若认为网站内容侵犯版权，请根据Xpirory版权侵权通知及下架政策提交报告。',
      msg48: '10. 数字服务法（DSA）',
      msg49: '根据欧盟DSA，若您需举报违规内容，请联系我们。欧盟委员会、成员国当局及数字服务委员会可通过business development@xpirory.com联系我们。',
    },
    // 代运营服务
    services: {
      msg1: '代理运营服务',
      msg2: '一站式提供<span>获客+商机转化</span>全流程开拓工具，<br />助您解决各类出海问题。',
      msg2_2: '一站式提供<span>获客+商机转化</span>全流程开拓工具，助您解决各类出海问题。',
      msg3: '出海获客代运营服务',
      msg4: '出海业务支持服务',
      msg5: '如果不想在前期投入专门的人员进行海外市场研究、客户查找和客户开发?<br />可以交给我们！',
      msg6: '如果没有专职的人手进行工具的数据搭建以及利用工具与海外客户进行沟通、交流及演示?<br />也可以交给我们！',
      msg7: '服务一',
      msg8: '服务二',
      msg9: '面向没有专门负责获客工作的客户，可以购买我们的出海获客代运营服务',
      msg10: '我们将提供以下的整体服务',
      msg11: '您将获得',
      msg12: '专业市场分析',
      msg13: '我们的分析师将运用专业的市场分析工具，对全球目标市场进行扫描、筛选与深度分析。我们不仅提供数据，更提供市场解读与建议，确保报告具有直接的战略指导意义。',
      msg14: '客户名单获取',
      msg15: '基于市场分析结论，我们的数据专家将从数亿条交易数据中，通过多种客户挖掘方法与筛选逻辑，为您精准定位真正和您业务对口的海外企业。此过程结论了大量数据研究和数据挖掘的方法论，帮您免除大量学习和筛选的时间。',
      msg16: '深度客户洞察',
      msg17: '名单仅是开始。我们的团队将借助专业的客户洞察工具深入研究名单中的多家重点客户，分析其业务背景、潜在痛点、潜在风险等多维度数据。这项工作旨在掌握与客户的最佳切入点，为精准营销奠定基础。',
      msg18: '个性化邮件拓客',
      msg19: '我们拒绝群发千篇一律的垃圾邮件。我们将结合名单中每个客户的背景及您的业务信息，为每个潜在客户量身定制多轮不用侧重点的个性化邮件营销内容。',
      msg20: '包含约定数量的多份潜力市场的详细分析报告，含市场规模、竞争格局、准入壁垒及优先进入建议。',
      msg21: '包含约定数量的高质量海外潜在企业的名单、关键联系人及联系方式。',
      msg22: '包含约定数量的针对重点客户的深度洞察报告，助您的销售团队在接触前即掌握主动权。',
      msg23: '代表您向约定数量的多家企业进行专业及个性化的拓客邮件触达。',
      msg24: '由此服务产生的有效询盘',
      msg25: '面向刚刚出海还没有掌握AI平台工具搭建和使用的客户，可以购买我们的出海业务支持服务',
      msg26_1: '痛点挖掘专家',
      msg26: '痛点挖掘服务',
      msg27: '痛点挖掘专家数据内容搭建服务',
      msg28: '协助您一同面向您的海外客户，使用工具对客户进行痛点及需求挖掘（线上支持）',
      msg29: '运营模拟分析服务',
      msg30: '运营模拟分析项目工程搭建服务',
      msg31: '协助您一同面向您的海外客户，使用工具对客户的运营现场进行模拟分析演示（线上支持）',
      msg32: '远程实景Demo服务',
      msg33: '远程实景Demo及培训平台',
      msg34: '远程实景Demo场景及房间搭建服务',
      msg35: '协助您一同面向您的海外客户，使用工具对客户进行实景Demo演示（线上支持）',
      msg36: '完整的平台工具',
      msg37: '免除安排专人进行数据搭建',
      msg38: '陪伴你们出海谈客户的远程业务支持顾问',
      msg39: '我们将提供以下产品与服务',
      msg40: '点击咨询',
    },
    // 不懂外语怎么和客户沟通及开会?
    problemCommunicate: {
      msg1: '不懂外语怎么和<br />客户沟通及开会？',
      msg2: '一站式提供<span>获客+商机转化</span>全流程开拓工具,<br />助您解决各类出海问题。',
      msg3: '现状和问题',
      msg4: '当下出海浪潮涌动，众多企业渴望开拓海外新市场，却被人才难题困住了脚步。招聘外语人才，需重新培训业务知识，不仅周期长，还会增加前期成本；而公司内部懂业务的核心员工，大多缺乏外语能力，无法直接与海外客户沟通对接。人才适配的双重顾虑，让不少企业迟迟不敢主动接触海外客户，始终难以迈出出海的关键第一步。',
      msg5: '我们的解决方案',
      msg6: '借助AI语音同传工具，让现有的业务人员快速迈出出海第一步',
      msg7: '公司现有的业务人员是最熟悉公司业务的人，借助AI语音同传工具，就可以低成本地快速让现有业务人员尝试开拓海外客户。在没了解清楚海外市场情况以及当地客户真实反馈前，无需盲目招聘精通外语的业务新人，降低前期投入成本。',
      msg8: '不管用的是 Zoom、Teams，还是其他会议平台，都能直接无缝接入，客户那边 “零准备” 就能直接参会，直接就能听到你的英文声音 —— 不用教操作，不用等调试，打开会议链接就能聊。',
      msg9: '低延迟同传翻译，边说边译，让客户感觉和本地人聊天一样流畅。这样你就能专心跟客户聊产品、谈合作，有效出海的前期成本。',
      msg10: '复用现有业务人员',
      msg11: '无需新招外语人才，依托熟悉业务的内部员工，快速启动出海尝试。',
      msg12: '降低前期成本',
      msg13: '避免盲目招聘、培训的额外投入，控制出海探索阶段的资金压力。',
      msg14: '适配多平台且零门槛',
      msg15: '无缝接入 Zoom、Teams 等主流会议工具，客户无需额外操作，打开链接即可参会沟通。',
      msg16: '沟通流畅无阻碍',
      msg17: '低延迟边说边译，还原本地化聊天体验，让业务人员专注产品与合作洽谈。',
      msg18: '语音同传及策略助手',
      msg19: '核心功能',
      msg20: '语音同传翻译',
      msg21: '沟通策略建议',
      msg22: '智能术语解析',
      msg23: '优势特点',
      msg24: '通用性强，无需客户提前调试',
      msg25: '低延迟同传翻译',
      msg26: '直接输出英文语音',
      msg27: '解决该问题所用的工具',
    },
    // 出国考察前要思考哪些问题?
    overseasInspection: {
      msg1: '如何最大化利用好<br />一次出国考察?',
      msg2: '一站式提供<span>获客+商机转化</span>全流程开拓工具，<br />助您解决各类出海问题。',
      msg3: '现状和问题',
      msg4: '当前，许多企业主想通过出国考察团了解海外市场是否适合自己的业务，却因前期研究缺失，使考察陷入“走马观花”的困境。其结果仅是获得碎片化印象，无法为核心商业问题提供答案，最终徒耗资源并增加决策风险。',
      msg5: '我们的解决方案',
      msg6: '通过提前的市场分析',
      msg7: '让考察从“漫无目的”变为“有的放矢”',
      msg8: '我们建议企业在进行昂贵的实地考察前，先利用我们的工具进行深入的市场研究。系统了解：目标市场的成熟度、饱和度如何？业务和目标市场是否适配？有哪些政策需要重点关注？文化和产品是否兼容？当地竞品竞争力如何？有哪些需要规避的风险？这样，实地考察的价值将聚焦于深度验证和细化报告中的关键发现，从而将考察之旅转化为高效、精准的商业决策过程。',
      msg9: '目标市场的成熟度、饱和度如何？',
      msg10: '业务和目标市场是否适配？',
      msg11: '有哪些政策需要重点关注？',
      msg12: '文化和产品是否兼容？',
      msg13: '当地竞品竞争力如何？',
      msg14: '有哪些需要规避的风险？',
      msg15: '数据雷达',
      msg16: '市场导航',
      msg17: '风险评估',
      msg18: '智能引导客户寻找细分市场',
      msg19: '全语种数据收集',
      msg20: '报告完整度是ChatGPT的3倍',
    },
    // 对海外某个客户不了解怎么办?
    customerInform: {
      msg1: '对海外某个客户<br />不了解怎么办？',
      msg2: '一站式提供<span>获客+商机转化</span>全流程开拓工具，<br />助您解决各类出海问题。',
      msg3: '现状和问题',
      msg4: '在开拓海外市场过程中，企业对目标客户缺乏深度了解是导致商机转化失败的核心痛点之一。由于语言壁垒和信息获取渠道有限，业务人员往往只能依靠官网信息和零碎的公开信息来评估客户，这种碎片化的认知难以支撑有效的业务切入。更严重的是，缺乏对客户组织架构、潜在痛点、竞争态势的系统性分析，导致企业在接触客户时难以精准切入需求，沟通内容流于表面，既无法展现专业价值，更可能因误判客户实际情况而造成资源投入的浪费。',
      msg5: '我们的解决方案',
      msg6: '针对客户认知盲区，业务人员可通过客户洞察工具在商机开发前期实现深度情报收集。业务团队输入目标客户基本信息后，工具基于AI能力自动抓取并整合多语种实时资讯，从多个维度生成深度分析报告：涵盖客户潜在痛点扫描、产品适配切入点、组织架构解析、竞争对手对比、合作风险评估等关键领域。结构化呈现客户全景画像，帮助企业在和客户相隔千里的情况下，也能精准定位合作策略，避免盲目接触。',
      msg7: '客户深度洞察',
      msg8: '从碎片化信息到全面的客户画像，洞察效率提升300%',
      msg9: '策略精准赋能',
      msg10: '基于客户痛点的个性化切入，拓客成功率提升50%-80%',
      msg11: '风险前置预判',
      msg12: '多维竞争与合作风险评估，高效决策资源分配',
      msg13: '跨语言壁垒破解',
      msg14: '全语种数据自动整合，消除信息不对称难题',
      msg15: '痛点扫描',
      msg16: '策略分析',
      msg17: '风险评估',
      msg18: '全语种数据收集',
      msg19: '深度匹配产品与客户业务',
      msg20: '报告完整度是ChatGPT的3倍',
    },
    // 国内团队能否做海外市场？
    domesticTeam: {
      msg1: '国内团队能否<br />做海外市场？',
      msg2: '当前，许多拥有成熟业务能力的国内团队在开拓海外市场时，往往受限于地理隔阂、语言障碍和文化差异，陷入“有实力、难触达”的困境。传统模式下，企业普遍认为要出海就必须一开始就组建本地化团队或频繁派遣人员出国，才能有效接触客户、理解需求并推进合作。这不仅导致人力与差旅成本激增，也因时差等问题导致信息传递不直接、响应速度慢，使得国内团队的业务经验难以快速转化为海外市场的竞争力，最终错失商机。',
      msg3: '借助Xpirory的AI工具矩阵，国内团队在出海初期即可高效接触海外市场。在获客与商机转化阶段，国内业务人员可先通过全球获客工具主动搜寻并锁定目标客户，摆脱地域限制；再借助客户洞察工具深度解析客户背景与潜在痛点，快速找到切入口。在实际沟通环节，语音同传工具可以实现跨语言实时交流，让资深业务人员直接与海外客户对话，在新团队还没全面掌握公司业务的时候，就能够开启海外业务。此外，配合邮件策略助手自动生成符合当地商务习惯的沟通内容，以及利用解决方案生成平台快速输出海外版的定制化方案，这样国内业务团队就能快速迈出出海的第一步了。',
      msg4: '打破地域壁垒',
      msg5: '国内团队直接触达并跟进海外客户，减少对出海前期缺少本地团队的问题。',
      msg6: '沟通零障碍',
      msg7: '语音同传实现边说边译，无惧和海外客户直接开会。',
      msg8: '响应敏捷化',
      msg9: '从客户洞察到方案输出全流程提速，商机转化周期缩短40%。',
      msg10: '成本结构优化',
      msg11: '减少出海前期海外团队搭建成本与高频差旅，人力与运营成本降低60%。',
      msg12: '多维度搜索客户',
      msg13: '采供链穿透',
      msg14: '竞品溯源',
      msg15: '海量真实交易行为数据',
      msg16: '覆盖全球230多个国家和地区',
      msg17: '关键决策人联系方式',
      msg18: '语音同传',
      msg20: '销售难题库',
      msg21: 'AI销售专家',
      msg22: '个性化指导',
      msg24: '覆盖全面的销售难题',
      msg25: '智能适配多国商务礼仪',
      msg26: '除了话术还有策略建议',
      msg27: '专业内容生成',
      msg28: '多语言输出',
      msg29: '可控方案模板',
      msg30: '支持上传参考文档',
      msg31: '企业模板布局可控配置',
      msg32: '可预设方案生成大纲',
    },
    // 客户不搭理你该怎么办？
    customerRespond: {
      msg1: '客户不搭理你<br />该怎么办？',
      msg2: '在海外业务开拓过程中，"客户不搭理"是常见却关键的瓶颈。群发出去的开发信往往因内容模板化、缺乏针对性，被客户视为"垃圾邮件"直接忽略。深层问题在于：传统邮件营销难以基于客户行业背景、业务阶段等维度实现真正个性化，导致沟通内容与客户实际痛点脱节；同时，跨文化商务习惯差异进一步降低了邮件的专业度和打开率，使优质商机在初始触达阶段即流失。',
      msg3: '针对客户沉默困境，企业可通过邮件策略助手与智能拓客邮件工具，在客户开发阶段实现精准突破。业务人员输入目标客户的企业规模、行业属性等背景后，工具基于AI自动解析客户潜在需求与现有业务的结合点，并结合不同营销场景生成"千人千面"的个性化邮件话术。邮件内容不仅涵盖多语种精准翻译，更融入当地商务礼仪与文化习惯，显著提升打开率与回复意愿。',
      msg4: '触达精准度跃升',
      msg5: '基于客户背景的动态话术生成，邮件打开率提升50%-80%。',
      msg6: '跨文化沟通无障碍',
      msg7: '内置多语种商务习惯翻译，避免因文化差异导致的沟通失效。',
      msg8: '全流程策略赋能',
      msg9: 'AI销售专家跟进不同阶段提供跟进建议，应对客户不同阶段的沉默原因。',
      msg10: '规模化个性触达',
      msg11: '通过AI辅助实现大批量快速生成个性化邮件，人效提升300%。',
      msg12: 'AI智能邮件话术生成',
      msg13: '多语种商务邮件翻译',
      msg14: '便捷邮件模板',
      msg15: '千人千面个性化沟通',
      msg16: '自适应跨文化沟通',
      msg17: '完整的沟通策略指导',
    },
    // 如何低成本出海?
    lowCost: {
      msg1: '如何低成本出海？',
      msg2: '当前，企业在出海初期普遍面临“高成本试错”的困境。传统拓客模式依赖线下考察、多语言团队组建和频繁差旅，导致资源消耗巨大。企业往往因信息不对称而盲目进入饱和市场，或因沟通障碍无法有效触达目标客户，初期投入如招聘外语团队、海外差旅等成本居高不下，却难以精准定位商机。更棘手的是，海外合作伙伴或新团队因业务理解不足，导致需求挖掘效率低下，方案响应延迟，进一步拉长转化周期，使出海陷入“投入高、回报慢”的恶性循环。',
      msg3: '针对低成本出海需求，企业决策者及业务团队可依托Xpirory一站式AI工具，在获客至商机转化全流程实现降本提效。通过AI市场分析工具精准锁定适配市场，避免盲目选择无效市场；利用全球获客工具主动挖掘潜在客户，替代高成本线下推广；借助语音同传工具赋能国内业务人员直接与海外客户沟通，减少初期多语言团队培训及试错的成本；通过痛点挖掘专家快速武装合作伙伴业务能力；结合解决方案生成平台高效响应客户需求；最后通过远程实景Demo平台替代差旅演示，实现全链条成本优化。',
      msg4: '市场定位精准化',
      msg5: 'AI多维分析减少盲目投入，市场筛选效率提升300%。',
      msg6: '全球获客高效化',
      msg7: '多维度搜素客户，快速获取大量有效的客户名单，效率提升300%以上。',
      msg8: '人力成本最优化',
      msg9: '利用语音同传现有业务人员直接参与海外沟通，初期团队组建成本降低50%。',
      msg10: '合作伙伴赋能化',
      msg11: '新人或伙伴快速掌握业务，需求挖掘效率提升300%。',
      msg12: '方案响应敏捷化',
      msg13: '多语言方案自动生成，定制效率提升500%。',
      msg14: '演示成本极致压缩',
      msg15: '远程实景Demo替代差旅，演示成本降低90%。',
      msg16: '多场景配置',
      msg17: '高ROI痛点收录',
      msg18: '最佳方案匹配',
      msg20: 'AI智能搜索',
      msg21: '分层知识体系',
      msg22: '可视化场景展示',
      msg23: '自然语言智能检索',
      msg24: '远程实景Demo及<br/>培训平台',
    },
    // 如何高效联系大量客户?
    customerContact: {
      msg1: '如何高效联系大量客户？',
      msg2: '在海外市场开拓过程中，企业常面临"海量客户差异化营销触达难"的瓶颈。传统模式下，业务人员需要逐一研究客户背景、逐一手工编写邮件，不仅耗时耗力，且难以保证内容质量。由于缺乏规模化个性内容输出的能力，也有企业直接通过群发营销邮件来触达客户，但往往因内容模板化被客户忽略，而纯靠人工手写又导致日均输出触达量有限，严重制约了业务拓展速度。更深层的问题在于，跨文化语境的精准表达要求高，非母语业务人员难以在保持效率的同时确保每封邮件的专业度与针对性。',
      msg3: '通过使用全球获客工具及邮件策略助手，企业的业务人员可在客户开发阶段实现规模化个性邮件触达。业务人员首先通过全球获客工具批量获取精准客户名单。随后借助邮件策略助手智能生成"千人千面"的个性化邮件内容。工具支持多语种自适应翻译，确保每封邮件既符合当地商务习惯，又精准匹配客户业务场景，使现有团队能同时处理数倍的高质量触达任务。',
      msg4: '营销效率倍增',
      msg5: '大幅提升现有人员的内容输出效率和客户触达量，人效提升500%。',
      msg6: '质量与规模兼得',
      msg7: '每封邮件均包含客户专属话术，回复率提升50%-80%。',
      msg8: '跨文化精准表达',
      msg9: '内置多语种商务习惯库，避免文化差异导致的沟通失效。',
    },
    // 如何找到目标客户？
    targetCustomer: {
      msg1: '如何找到目标客户？',
      msg2: '出海初期的企业在找客户的方法上难以理清各种方式的先后顺序和组合关系，导致耗费大量的时间的资金，但却收效不佳。面对建立海外团队、广告投放、海外展会、社媒平台开发和数据采购等多种渠道，企业因缺乏对目标市场的清晰洞察，难以制定高效的获客组合策略。盲目投入高成本广告可能导致预算浪费，而远赴海外参加展会效率又低……。核心问题在于，企业在没有接触过目标市场的客户时，无法快速、低成本地识别出客户的渠道偏好；无法了解哪些区域客户需求最旺盛；以及真正有采购意向的精准客户的采购习惯是怎么样的？这些问题都导致寻找目标客户难，成本高。',
      msg3: '在海外客户开发的起步阶段，我们建议可以遵循先线上，再线下，主动获客及被动获客相结合的原则。初期通过使用我们的全球获客工具，直接搜索并锁定有过相关产品交易记录的真实采购商，一键获取关键联系人。企业可让现有的业务人员先利用此工具低成本地进行线上侦察，主动快速地接触大量目标客户。通过与客户的接触和研究，量化评估不同市场的客户画像，需求活跃度，从而为海外广告投放、线下展会、海外团队部署等重大投入决策提供有效指引，逐步扩大品牌影响力，源源不断地获取更多的精准客户。<br/>这样带来的直接效果是：',
      msg4: '精准获客',
      msg5: '直接从“大海捞针”变为“清单式开发”，精准获取有真实交易记录的潜在客户及其联系方式。',
      msg6: '降低成本',
      msg7: '大幅减少在多种渠道上的盲目投入，优化整体获客预算的分配效率。',
      msg8: '决策有据',
      msg9: '为是否参加某地区展会、是否建立本地团队等决策提供数据支持，避免盲目投入。',
      msg10: '提升效率',
      msg11: '将漫长的客户搜寻过程缩短至几分钟，快速锁定目标，加速销售 pipeline 的构建。',
    },
    // 适合自己的海外市场在哪里?
    overseasMarket: {
      msg1: '适合自己的<br />海外市场在哪里?',
      msg2: '当前，企业在出海决策的初始阶段普遍面临“举棋不定”的情况，因为大家一开始都不清楚适合自己的海外市场在哪里。决策者往往只能通过中文或英文，搜索自己看得懂的资料，难以研究不同语种的真实资讯。这种信息不对称导致市场选择如同“大海捞针”。企业可能因误判市场饱和度而盲目进入红海，或因忽视本地化政策、文化禁忌而水土不服，最终使出海之旅在起点就埋下了高失败率的隐患。核心困境在于缺乏一个能够整合多维度、实时、本地化信息的系统性分析工具，来将模糊的出海意向转化为清晰的出海目标。',
      msg3: '通过获取详细的市场分析报告，轻松选出最适合您业务落地的国家与细分领域',
      msg4: '在决策前通过使用我们的AI市场分析工具，我们能够帮助企业决策者将市场选择从“主观猜测”变为“数据驱动”。您只需输入业务核心要素以及想研究的市场，我们的工具将自动执行多语言实时资讯抓取与智能分析，从市场环境、政策合规、文化适配到竞争格局进行全方位扫描与评估，输出专业的市场分析报告，从而帮助企业确定匹配度最高的潜力市场。',
      msg5: '精准定位',
      msg6: '从“可能适合”到“最优选择”，轻松选出最适合您业务落地的国家与细分领域。',
      msg7: '效率倍增',
      msg8: '将原本需要数周的人工调研过程缩短至几分钟，快速生成深度洞察，抢占市场先机。',
      msg9: '风险预判',
      msg10: '提前揭示潜在的政策、文化、竞争风险，将“事后补救”变为“事前规避”，显著降低试错成本。',
      msg11: '决策赋能',
      msg12: '为您提供一份深度、结构化、远超ChatGPT 3倍信息量的专业报告，为最终的出海决策提供坚实依据。',
    },
    // 海外产品演示成本过高怎么办?
    demonstrateCost: {
      msg1: '海外产品演示成本<br>过高怎么办?',
      msg2: '海外产品演示面临"三高"困境：高差旅成本、高时间成本、高设备运输成本。传统演示模式依赖团队携设备赴现场，单次演示成本极高。更关键的是，演示机会因成本限制大幅减少，导致优质商机转化率降低。此外，突发政策变化可能使筹备数月的演示计划突然中止，造成资源严重浪费。',
      msg3: '通过远程实景Demo及培训平台，实现从设备展示到操作交互的全程线上化。出海企业可以将自己的产品/方案搭建在远程实景Demo平台上。海外客户通过专属链接接入平台，实时远程操控设备，并通过多视角高清画面全方位自主观察，全面体验产品/方案的实际应用效果。',
      msg4: '真实设备远程实时操控',
      msg5: '客户直接远程操作真实设备，获得沉浸式体验。',
      msg6: '多视角自主观察',
      msg7: '提供多角度高清画面，客户可自主切换查看。',
      msg8: '一键接入零门槛',
      msg9: '一键链接接入，客户无需安装任何软件。',
      msg10: '突破时空限制，高效推进项目',
      msg11: '客户无需差旅即可进行深度产品验证，显著节省成本，极大缩短决策周期。',
      msg12: '直观展示产品方案',
      msg13: '灵活搭建接入自有场景',
      msg14: '实景操控沉浸体验',
      msg15: '演示地点和时间灵活',
      msg16: '提供远程在线的互动体验',
    },
    // 海外新人或者合作伙伴如何快速掌握业务?
    businessMastery: {
      msg1: '海外新人或者合作伙伴<br>如何快速掌握业务？',
      msg2: '海外新人或合作伙伴在接手业务初期，往往面临"经验断层"的挑战。由于不熟悉企业产品体系与行业特性，他们在面对客户时难以系统性地挖掘潜在需求，容易出现痛点遗漏或方案匹配偏差。资深顾问虽能通过长期积累精准把握客户需求，但人力有限无法大面积配合所有同事与客户进行沟通，导致海外业务拓展效率低下，大量潜在商机因前线人员能力不足而流失。更深层的问题在于，企业缺乏将核心业务知识转化为可快速复用的标准化工具，使得每次新人培养都需投入大量时间成本。',
      msg3: '针对海外团队能力建设需求，企业可通过痛点挖掘平台在商机转化阶段实现快速赋能。该平台通过构建企业专属的“业务场景地图”，将行业高价值痛点与最佳实践方案结构化整合，形成分层知识体系。新人或合作伙伴在面对客户时，只需根据行业分类与业务场景逐步引导，即可匹配客户的全部潜在痛点。同时，配合AI智能检索功能，实时响应客户提出的碎片化问题，快速关联最佳实践方案，使零经验人员也能具备专家级的业务挖掘能力。',
      msg4: '挖掘效率倍增',
      msg5: '痛点地图与方案匹配，需求挖掘效率提升300%-500%。',
      msg6: '知识沉淀赋能',
      msg7: '将专家经验转化为可复用的分层知识体系，新人快速具备资深顾问能力。',
      msg8: '方案精准匹配',
      msg9: '基于企业最佳实践库智能推荐方案，客户需求匹配度提升50%以上。',
      msg10: '跨团队协同优化',
      msg11: '全球各地的销售团队和海外合作伙伴可同步使用统一标准挖掘工具，减少培训成本80%。',
    },
    // 客户需求不清晰怎么办？
    unclearDemand: {
      msg1: '客户需求不清晰怎么办？',
      msg2: '在B端业务拓展过程中，"客户需求不清晰"是阻碍商机转化的典型瓶颈。尤其当企业面对行业经验不足的销售新人或海外合作伙伴时，往往因缺乏系统化的需求挖掘方法论，导致他们和客户对话时仅能流于表面：要么遗漏关键痛点，要么陷入无效问答循环。资深顾问虽能通过经验快速定位需求，但人力有限难以覆盖所有客户，最终造成高价值商机流失。更深层的问题在于，企业未能将散落的业务知识转化为可复用的挖掘体系，使每次客户沟通都变成毫无章法的消耗战。',
      msg3: '针对客户需求模糊的困境，企业可在商机转化阶段通过痛点挖掘平台实现系统性破局。销售团队或合作伙伴只需选择客户所属行业及业务场景，即可匹配该领域的高频痛点库，快速筛选锁定客户的全部痛点问题，并提供对应的解决方案。此外，通过AI驱动的自然语言检索，也可以根据客户提出的问题，快速定位匹配的解决方案。工具内置的"业务场景地图"通过可视化的方式展示客户潜在的痛点问题，而智能搜索功能则能实时响应客户提出的碎片化问题，快速关联最佳实践方案，使即使零经验销售人员也能像专家顾问一样对客户的深度需求进行全面挖掘，推动商机的转化。',
    },
    // 如何高效应对多个客户的产品/方案需求?
    efficientResponse: {
      msg1: '如何高效应对多个客户<br>的产品/方案需求？',
      msg2: '在海外业务拓展过程中，企业常面临"多客户并发需求"的挑战。当销售或者售前需要同时应对多个海外客户时，传统的方案制作方式始终无法快速响应客户多变的需求：业务人员需要查阅分散的产品资料，手动整合资料并输出针对性解决方案，再通过耗时的人工翻译转换为多语言版本。这一过程不仅消耗大量专业人力资源，且往往因为客户前期采购意向不明确，导致大量投入的浪费，进而影响真正的有效商机转化效率。',
      msg3: '通过解决方案生成平台，业务人员在商机转化阶段可实现多客户需求的并行高效处理。业务人员只需输入客户核心需求，并选定企业的相关知识文档（产品资料、案例库、技术文档等），平台即可智能提取关键信息，结合可自定义的PPT模板，自动生成结构完整、内容专业的解决方案。系统支持多语言实时翻译，确保输出内容符合当地商务习惯，同时提供在线编辑工具便于手动快速调整优化。',
      msg4: '效率突破性提升',
      msg5: '方案制作时间从数天压缩至小时级，效率提升500%。',
      msg6: '质量标准化保障',
      msg7: '通过可控模板确保专业度。',
      msg8: '全球化无缝适配',
      msg9: '内置外语翻译引擎，轻松应对跨国业务需求。',
      msg10: '知识资产沉淀',
      msg11: '所有生成方案可分类归档，形成可复用的企业专属方案知识库。',
    },
    // 如何减少商机转化的差旅成本?
    travelExpenses: {
      msg1: '如何减少商机转化<br>的差旅成本？',
      msg2: '在传统海外业务拓展模式下，商机转化高度依赖实地差旅。一种方式是通过在当地建立本地话团队进行市场开拓。另一种方式是通过团队频繁往返目标市场进行客户拜访、需求调研和方案演示。这两种"面对面"驱动的模式导致差旅成本占总投入比重非常高。更关键的是，如果团队在目标市场长期无法产生有效结果时，会导致企业陷入“高成本、低韧性”的运营困境。',
      msg3: '出海初期优先开发海外合作伙伴能充分借助其本地化优势，快速贴近当地市场与客户，降低企业直接出海的陌生感与落地成本，而通过痛点挖掘平台 + 语音同传工具 + 远程实景 Demo及培训平台的组合应用，我们能为合作伙伴提供全方位赋能，最终实现合作共赢。这种组合构建了从需求对接到方案验证的线上协作能力，让合作伙伴可依托总部专家团队的远程支持，形成“本地触达 + 中央支持”的高效模式。总部团队可以配合当地合作伙伴通过痛点挖掘平台引导客户梳理业务痛点，既保证需求挖掘深度与现场访谈相当，又避免前期信息偏差导致的不必要差旅。在沟通环节，语音同传工具支持总部专家直接参与客户会议，以低延迟翻译、术语解析消除语言壁垒，让沟通效率大幅提升。即使是方案验证阶段，远程实景 Demo 平台可实现产品/方案的线上沉浸式演示，客户通过多视角摄像头实时观察设备运行状态，操控体验方案/产品的应用效果，让体验感逼近现场。出海前期通过这种方式能辅助合作伙伴更专业地服务客户，同时也能减少差旅成本，达成共赢。',
      msg4: '差旅成本锐减',
      msg5: '当地合作伙伴+关键环节线上化，使差旅成本大幅降低。',
      msg6: '响应速度提升',
      msg7: '由当地合作伙伴线下配合，大幅提升客户需求的响应速度。',
      msg8: '资源优化配置',
      msg9: '专家可同时支持多个区域项目，人效提升300%。',
      msg10: '风险韧性增强',
      msg11: '降低企业在大量押注单一海外市场时带来的运营风险。',
    },
    // 如何快速建立海外客户对你的专业印象?
    majorImpression: {
      msg1: '如何快速建立<br>海外客户对你的专业印象？',
      msg2: '在海外业务拓展中，销售人员想要建立专业印象常常面临三重挑战：一是初次接触时因缺乏对客户行业的深度理解，难以展现专业的潜在痛点洞察力；二是面对客户需求时方案响应速度慢，且内容缺乏针对性；三是跨语言沟通中术语不熟悉、应对质疑不及时，易让客户产生不信任感。传统业务开拓过程中，主要是依赖资深顾问的个人能力，但由于团队的每个人能力参差不齐，且能力全面的人才有限，难以保证每个客户接触时都能呈现一致的专业水准。',
      msg3: '通过三大 AI 工具的协同作用，企业可在客户接触期间系统化塑造专业形象。业务人员首先运用痛点挖掘平台梳理客户行业与业务瓶颈，借助分层知识体系匹配高价值痛点，在初次接触时全面梳理出客户的关键业务场景，充分展现对行业的深度理解；随后基于客户需求调用解决方案生成平台，调用企业知识库快速生成专业方案文档，且支持实时调整以确保方案与客户需求精准匹配，直观印证专业的响应能力；在实际沟通环节，依托语音同传工具实现无缝跨语言交流，同时利用AI 实时分析对话内容并提供针对性的应对策略，搭配智能术语解析功能有效消除专业术语壁垒，让业务人员在与海外客户交流中从容应对各类专业质询，建立全面的专业形象。',
      msg4: '专业能力提升',
      msg5: '系统化的痛点挖掘能力，显著增强客户信任度。',
      msg6: '响应速度突破',
      msg7: '从需求接收到方案输出全程提速500%，展现高效专业形象。',
      msg8: '语言障碍消除',
      msg9: '低延迟同传翻译配合术语解析，使沟通流畅度接近母语水平。',
      msg10: '沟通策略辅助',
      msg11: '实时策略建议帮助规避表达卡顿，专业术语不理解的问题。',
    },
    // 商机推进不下去了怎么办？
    businessPromote: {
      msg1: '商机推进不下去了<br>怎么办？',
      msg2: '在海外业务拓展过程中，商机推进受阻是常见的痛点。销售流程往往在破冰、需求确认、价格谈判等关键节点陷入僵局。由于跨文化沟通障碍、缺乏针对性话术或应对策略不当，导致客户兴趣衰减或决策延迟。传统模式下，销售团队依赖个人经验应对难题，但海外市场变量多、客户背景复杂，单一经验难以覆盖所有场景。更严重的是，僵局持续会引发内部资源空转，竞争对手乘虚而入，最终使前期投入的获客成本付诸东流。',
      msg3: '当商机推进遇阻时，销售团队可在商机转化阶段使用困境策略大师实现智能破局。工具借助AI的能力，智能分析销售漏斗中各阶段卡点（如客户沉默、异议处理、谈判僵持），从策略建议到具体话术提供全链条支持。系统内置多国商务礼仪库，确保翻译后的沟通方式符合当地文化习惯，同时结合企业专属信息生成个性化指导方案，使销售人员在面对复杂情境时也能从容应对。',
      msg4: '策略精准性提升',
      msg5: 'AI智能拆解销售难题，提升应对策略的有效性。',
      msg6: '沟通效率优化',
      msg7: '实时话术生成将响应时间从小时级缩短至分钟级，加速僵局破解速度。',
      msg8: '跨文化适配无忧',
      msg9: '翻译时自动融入目标市场商务礼仪，客户信任度提升50%以上。',
      msg10: '转化率显著改善',
      msg11: '通过全流程难题库支持，显著推动商机转化效率。',
    },
    // 遇到海外客户的挑战/质疑如何应对？
    challengeRespond: {
      msg1: '遇到海外客户的<br>挑战/质疑如何应对？',
      msg2: '在海外业务拓展过程中，应对客户的实时质疑和挑战是常见的难点。由于语言障碍、文化差异及专业知识不对称，业务人员往往难以快速组织有说服力的回应，容易陷入被动。线上会议中的即时质疑需要秒级反应速度，而邮件等书面沟通又要求措辞精准严谨。以前只能依赖个人临场发挥，缺乏更便捷的支持工具，导致沟通效果不稳定，甚至影响客户信任。',
      msg3: '针对海外客户的挑战场景，企业可通过语音同传及策略沟通助手与销售困境策略大师的协同，构建覆盖 “实时会议 + 书面沟通” 的全场景应对方案。在线上会议中，业务人员借助语音同传及策略沟通助手实现低延迟翻译，同时 AI 会实时捕捉客户质疑关键词，自动推送应对策略与话术，搭配智能术语解析功能快速解释专业概念，避免知识盲区导致的沟通卡点；而在书面沟通场景，可通过销售困境策略大师选择当前遇到的销售难题，AI 会基于行业难题库生成结构化回应框架，再结合客户背景与企业优势自动优化话术角度与表达方式，且支持多语种版本一键生成，确保跨文化语境下的表述精准度。',
      msg4: '响应速度提升',
      msg5: 'AI快速提供应对话术及策略建议，响应速度大幅提升。',
      msg6: '沟通效率突破',
      msg7: '再也不用自己绞尽脑汁思考应对话术，AI辅助提升沟通效率。',
      msg8: '风险控制优化',
      msg9: '结构化回应框架减少表述失误情况，客户满意度提升50%。',
      msg10: '跨场景覆盖完善',
      msg11: '双工具协同实现线上线下质疑应对的全面覆盖。',
      msg12: '语音同传及策略沟通助手',
      msg13: '销售困境策略大师',
    },
    // 遇到竞争对手冲击怎么办？
    opponentImpact: {
      msg1: '遇到竞争对手冲击<br>怎么办？',
      msg2: '在海外市场拓展过程中，竞争对手的冲击是难以避免的挑战。企业常面临竞品突然降价、针对性方案截胡、关键技术被模仿等多维度冲击。由于信息不对称和响应机制滞后，销售团队往往陷入被动应对状态：既缺乏对竞争对手动态的实时掌握，又缺少系统化的反制策略。更严重的是，跨文化语境下难以快速组织有说服力的应对话术，导致客户信任度动摇，甚至已推进至后期的商机被竞争对手强势夺走。',
      msg3: '通过困境策略大师的智能化支持，销售团队可在商机转化全阶段构建敏捷响应能力。当了解到竞争对手的相关信息时，销售人员只需输入竞争背景（如竞品报价、技术对比、客户疑虑等），工具即基于多维度销售经验数据自动生成破局策略：从策略分析到差异化设计，从价值重塑到风险预判，形成完整应对话术，辅助销售快速破解。',
    },
    tools: {
      msg1: 'AI获客及商机转化工具',
      msg2: 'AI获客及<br>商机转化<br>工具',
      msg3: '代理运营<br>服务',
      msg4: '免费领 3 个精准客户！含关键联系人 + 定制开发信，填表单即得',
      msg5: '免费获取',
      msg6: '【免费获取】3个匹配您业务的潜在客户+1个关键联系人+1封个性化开发信',
      msg7: '免费获取',
    }
  },
  ...zhLocale,
};

export default cn;
